export const messages = {
  en: {
    account: 'Account',
    login: 'Log in',
    logout: 'Log out',
    loginWithMicrosoft: 'Log in with Microsoft',
    pleaseWait: 'Please wait',
    /*errors*/
    error: 'Error',
    not_authorized: 'User not authorized',
    Unauthorized: 'User not authorized',
    EMAIL_NOT_FOUND: 'EMAIL_NOT_FOUND',
    user_is_not_admin: 'User must be admin',
    user_is_not_found: 'User is not found',
    error_login_user_not_found: 'User not found',
    user_not_found: 'User not found',
    user_single_pharmacy: 'User has only one pharmacy',
    pharmacy_not_found: 'Pharmacy not found',
    pickupbox_not_found: 'Pickupbox not found',
    template_not_found: 'Template was not found',
    alarm_not_found: 'Alarm not found',
    delivery_not_found: 'Delivery not found',
    delivery_has_no_ssn: 'Delivery has no ssn data',
    ssn_mismatch: 'SSN mismatch',
    link_not_found: 'Verification link was not found',
    not_enough_permissions: 'Not enough permissions to perform',
    error_session_expired: 'Session expired',
    no_content: 'No content',
    forbidden: 'Pharmacy access denied',
    not_found: 'User not found',
    unknown: 'Unknown error',
    wrong_pin_code: 'Pin Code is wrong',
    wrong_phone_number: 'Phone number do not match delivery',
    kolli_id_mismatch: 'Kolli Id mismatch',
    already_has_access: 'User already has access to current pharmacy',

    user_with_email_does_not_exist: 'User with this email does not exist',
    error_login_too_many_attempts: 'Too many login attempts try again later',
    error_login_user_not_found_or_wrong_password:
      'User not found or wrong password',

    newPassword_missing: 'New password is missing',
    repeatNewPassword_missing: 'Repeat new password is missing',
    oldPassword_missing: 'Old password is missing',
    newPassword_not_matches_repeatedNewPassword:
      'The new password does not match the repeated new password',
    oldPassword_matches_newPassword:
      'The old password matches the new password',

    firstName_empty: 'First name is empty',
    lastName_empty: 'Last name is empty',
    email_empty: 'Email is empty',
    invalid_role: 'The wrong role',
    this_role_is_greater_than_yours: 'This role is greater than yours',
    email_missing: 'Email is missing',
    firstName_missing: 'First name is missing',
    lastName_missing: 'Last name is missing',
    appLanguage_missing: 'App language is missing',
    role_missing: 'Role is missing',
    pharmacyIds_must_match: 'Pharmacy IDs must match',

    pharmacyId_missing: 'Pharmacy ID is missing',
    webToolAccess_missing: 'No access to the web tool',
    boxAccess_missing: 'No access to the box',
    roleName_missing: 'Role name is missing',
    role_not_exist: 'The role does not exist',

    name_missing: 'Name is missing',
    businessId_missing: 'Business ID is missing',
    not_valid_strong_auth_value: 'Invalid value strong auth',
    businessId_already_exists: 'Business ID already exists',
    pharmacy_templateId_missing: 'Pharmacy template ID is missing',
    pharmacy_id_missing: 'Pharmacy ID is missing',
    pharmacy_country_missing: 'Pharmacy country is missing',
    pharmacy_language_missing: 'Pharmacy language is missing',
    pharmacy_city_missing: 'Pharmacy city is missing',
    pharmacy_outdoor_missing: 'Pharmacy outdoor is missing',
    pharmacy_uiLanguages_missing: 'Pharmacy UI languages are missing',
    pharmacy_zipCode_missing: 'Pharmacy zip code is missing',
    pharmacy_cardboardType_missing: 'Pharmacy cardboard type is missing',
    pharmacy_already_exists: 'The pharmacy already exists',
    pharmacy_does_not_exist: 'No pharmacy exists',
    not_valid_strong_auth_value_pharmacy_update:
      'Invalid pharmacy update with a strong authorization value',
    shelves_are_in_use_cant_change_number: 'Pharmacy update failed',

    pickupbox_templateId_missing: 'Pickupbox template ID is missing',
    pickupbox_name_missing: 'Pickupbox name is missing',
    pickupbox_id_missing: 'Pickupbox ID is missing',
    pickupbox_country_missing: 'Pickupbox country is missing',
    pickupbox_language_missing: 'Pickupbox language is missing',
    pickupbox_city_missing: 'Pickupbox city is missing',
    pickupbox_outdoor_missing: 'Pickupbox outdoor is missing',
    pickupbox_uiLanguages_missing: 'Pickupbox UI languages are missing',
    pickupbox_zipCode_missing: 'Pickupbox zip code is missing',
    pickupbox_cardboardType_missing: 'Pickupbox cardboard type is missing',
    pickupbox_already_exists: 'Pickupbox already exists',
    pickupbox__does_not_exist: 'No pickupbox exists',

    missing_fields: 'Missing fields',
    reserved_locker_cannot_be_inactive: 'A reserved locker cannot be inactive',
    locker_do_not_exist: 'The locker does not exist',
    can_not_assign_to_box: 'Delivery can not be assigned to box',

    user_is_logged_in_to_box: 'The user is logged in to the Pick-up Box',
    reservation_delivered: 'Reservation delivered',
    pickupbox_disabled: 'The pickupbox is turned off',
    user_is_logged_in_to_box_not_create_reservation:
      'The user entered the field not to create a reservation',

    pickupbox_disabled_invalid_locker: 'The pickupbox disabled invalid locker',
    user_is_logged_in_to_box_invalid_locker:
      'The user is logged into an invalid Pick-up Box locker',
    invalid_locker: 'Invalid locker',
    locker_already_reserved: 'The locker is already reserved',
    wrong_delivery_status: 'Wrong delivery status',
    permissions_empty: 'Permissions are empty',
    bad_strong_auth_provider:
      'Bad server configuration, no provider for strong authentication given',
    authentication_link_has_expired: 'Authentication link has expired',

    validation: {
      required: 'This field is required.',
      email: 'Please enter a valid email address.',
      phoneNumber: 'Phone number format: +xxxxxxxxxxxx',
      length: 'This field should be 6 characters long.'
    },
    /*info*/
    address: 'Address',
    languages: 'Languages',
    versionSW: 'SW Version',
    temperatureInterval: 'Temperature Interval',
    temperatureAlarmInterval: 'Temperature Alarm Interval',
    email: 'Email',
    emailUpperCase: 'EMAIL',
    alarmEmail: 'Alarm Email',
    password: 'Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    phoneNumber: 'Phone Number',
    pinCode: 'Pin Code',
    shelvesNumber: 'Number of shelves',
    chooseShelf: 'CHOOSE SHELF',
    show: 'show',
    showUpperCase: 'Show this page',
    mobilePhone: 'Mobile Phone',
    mobilePhoneUpperCase: 'MOBILE PHONE',
    alarmPhoneNumber: 'Alarm Phone Number',
    firstName: 'First name',
    firstNameUpperCase: 'FIRST NAME',
    lastName: 'Last name',
    lastNameUpperCase: 'LAST NAME',
    name: 'Name',
    nameUpperCase: 'NAME',
    pharmacyNameUpperCase: 'PHARMACY NAME',
    roleUpperCase: 'ROLE',
    role: 'Role',
    keyUpperCase: 'KEY',
    key: 'Key',
    id: 'ID',
    reservationKeepTime: 'Reservation Keep Time',
    pickupBoxName: 'Pick-up Box Name',
    pickupBoxId: 'Pick-up Box ID',
    city: 'City',
    country: 'Country',
    zipCode: 'Zip Code',
    UILanguages: 'UI Languages',
    defaultLanguages: 'Default Languages',
    cardboardType: 'Pick-up Box cardboard type',
    userIdUpperCase: 'USER ID',
    deliveryStatusUpperCase: 'DELIVERY STATUS',
    deliveryStatus: 'Delivery status',
    kolliIDUpperCase: 'KOLLI-ID',
    lockerID: 'Locker-ID',
    lockerIDUpperCase: 'LOCKER-ID',
    lockerIdOrShelfUpperCase: 'LOCKER-ID / PKT',
    lockerIdOrShelf: 'Locker-ID / PKT',
    orderExpired: 'Order Expired',
    orderExpiredUpperCase: 'ORDER EXPIRED',
    causeOfAlarmUpperCase: 'CAUSE OF ALARM',
    orderID: 'Order-ID',
    lang: 'Language',
    desktopLang: 'Desktop Language',
    pharmacyInfo: 'Pharmacy Info',
    userBoxPin: 'User Box Pin',
    farmacyEntryPin: 'Pharmacy Entry Pin',
    oldLogin: 'Old login',
    newLogin: 'New login',
    userBoxId: 'User Box ID',
    pharmacyReservations: 'Pharmacy Reservations',
    lastUpdate: 'Last Update',
    kolliID: 'Kolli-ID',
    timeReserved: 'Time Reserved',
    timeDelivery: 'Time Delivery',
    timePickup: 'Time Pickup',
    timeDelete: 'Time Delete',
    timeExpired: 'Time Expired',
    deliveryMadeBy: 'Delivery Made By',
    description: 'Description',
    resendSMSCounter: 'Amount of SMS sent:',
    resendSMSTimestamps: 'Time of the last SMS sent:',
    descriptionUpperCase: 'DESCRIPTION',
    comment: 'Comment',
    reservationMadeByUpperCase: 'RESERVATION MADE BY',
    deliveredByUpperCase: 'DELIVERED BY',
    assignedTimeByUpperCase: 'ASSIGNED AT',
    assignedTime: 'Assigned at',
    assignedUserName: 'Assigned',
    fulfillment_order_id: 'Fulfillment order id',
    order_id: 'Order-ID',
    reservedUserName: 'Reservetion made by',
    pickupboxPageAssignDelivery: 'PICKUPBOX PAGE ASSIGN DELIVERY',
    lastLoginUpperCase: 'LAST LOGIN',
    userUpperCase: 'USER',
    typeUpperCase: 'TYPE',
    assignUpperCase: 'ASSIGN',
    alarmOk: 'Everything is fine with the locker',
    alarmDoorOpen: 'The locker does not close',
    alarmDoorClosed: 'The locker does not open',
    alarmTempHigh: 'The temperature in the locker is high',
    alarmTempLow: 'The temperature in the locker is low',
    alarmOther: 'No data on the locker is available',
    alarmMissing: 'Locker data is missing',
    connection_lost: 'Connection lost',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    roomTemp: 'Room temp',
    includesDrug: 'Includes drug',
    includesDrugUpperCase: 'INCLUDES DRUG',
    narcoticsUpperCase: 'NARCOTICS',
    log: 'Log',
    min: 'min',
    minute: ' minute',
    minutes: ' minutes',
    hour: 'hour',
    hours: 'hours',
    day: ' day',
    days: ' days',
    daysDelivery: 'Days',
    averagePickupTime: 'AVG PickupTime',
    Hours: 'Hours',
    basicLocker: 'Basic locker:',
    fridgeLocker: 'Fridge locker:',
    deliveryExpirationTime: 'Delivery expiration time',
    reminderMessageTime: 'Reminder message time',
    reservationExpirationTime: 'Reservation expiration time',
    fullHistory: 'Full history',
    /*actions*/
    forgotPassword: 'Forgot Password?',
    sendResetLink: 'Send reset link',
    backToLogIn: 'Back to Log in',
    sentEmail: 'Password reset email sent.',
    edit: 'Edit',
    add: 'Add',
    chooseLanguage: 'Choose languages for SMS',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    cleanFields: 'Clean fields',
    search: 'Search',
    makeServiceRequest: 'Make a service request',
    seriviceRequested: 'Service requested',
    referToHelpdesk: 'Refer to our helpdesk',
    addUser: 'Add User',
    removeFromMyPharmacy: 'Remove from my pharmacy',
    loginInformation: 'Login Information',
    selectMultipleLockers: 'Select Multiple Lockers',
    chooseSeveralShelves: 'Choose several shelves',
    disableLocker: 'Disable Locker',
    locker: 'Locker',
    reservation: 'Reservation',
    delivery: 'Delivery',
    deleteReservation: 'Delete Reservation',
    reserve: 'Reserve',
    newBookingPharmacyPickup: 'New booking pharmacy pickup',
    exportJSON: 'Export.json',
    importJSON: 'Import.json',
    downloadCSV: 'Download.csv',
    downloadTempCSV: 'Download temperatures.csv',
    downloadPDF: 'Download.pdf',
    createReservation: 'Create Reservation',
    webToolAccess: 'Access to web tool',
    boxAccess: 'Access to box',
    ok: 'Ok',
    happy: 'Happy',
    angry: 'Angry',
    yes: 'Yes',
    no: 'No',
    noTable: 'No',
    and: 'and',
    verifySSN: 'Verify SSN',
    pickupForAnotherSSN: 'Pickup for another SSN',
    verify: 'Verify without SSN',
    assignReservation: 'Pick-up Box page Assign Reservation',
    redirectToPickupBox: 'Redirect to PickupBox',
    quickReservation: 'Quick reservation',
    quickReservationLockers: 'Manual quick reservation',
    isDrug: 'Drug contain',
    drug: 'Drug',
    ssn: 'SSN',
    ssnPickUp: 'Pick Up SSN',
    ssnForOtherPerson: 'SSN for the person picking up',
    resendSMS: 'Resend SMS',
    showFullHistory: 'Show full history',
    hideFullHistory: 'Hide full history',
    /*text*/
    pageNotFound: 'Page Not Found',
    checkURL:
      'The specified file was not found on this website. Please check the URL for mistakes and try again.',
    forgotPasswordTex:
      'Please enter your email address and we will send you an email. By following the link in the email you will be able to enter your new password.',
    passwordCharacters: 'Password should contain at least 8 characters.',
    youWantDelete: 'Are you sure you want to delete',
    descriptionDestroy:
      'Destroy – Move the reservation to history. That is to be used when you do destruction.',
    descriptionDelete:
      'Delete – Move the reservation back to the "API reservations" tab, i.e. cancel the reservation to reserve a new slot.',

    descriptionCancel: 'Cancel – Close window without action.',
    youWantDeleteReservation: `  `,
    undone: '? This change cannot be undone.',
    changePasswordInfo:
      'INFO: Memorize the password and hand it over to the user. You cannot recover the password later. Password should contain at least 8 characters.',
    noPickupBox: 'No Pick-up Box',
    noFeedback: 'No Feedback',
    addDescription: 'Add description to delivery history',
    infoReservation: 'Information about the reservation',
    addAlarmComment: 'Add Alarm comment',
    deviationsInTimeFrame: 'Deviations in time frame',
    addUserMainInfo:
      'INFO: Memorize the password and hand it over to the user. You cannot recover the password later.',
    addUserInfo: 'Password should contain at least 8 characters.',
    lockersSelected: 'lockers are selected',
    messageTemperatureHigh: 'Locker temperature is too high: ',
    messageTemperatureLow: 'Locker temperature is too low: ',
    noData: 'No data',
    errorDate: 'Error date',
    noReservations: 'No Reservations',
    noOrderReservedYet: 'No Order reserved yet.',
    enableLocker: 'No Order reserved yet. Enable Locker to reserve orders.',
    noAlarms: 'No alarms during selected time period',
    assignDeliveryFromDesk: 'Assign Delivery to be picked-up from desk',
    updateDelivery: 'Update Delivery',
    assignDeliveryFromLocker:
      'Assign Delivery to be picked-up from the PickUp Box',
    assignToLocker:
      'If you want this delivery to be picked up from a Pickup! box, press the "Redirect to PickupBox" button. Click on an empty slot and select "Pick-up Box page Assign Reservation".',
    pickedUpRevervation: 'Was the reservation picked up?',
    chooseDelivery: 'Choose the delivery from the list',
    chooseThisDelivery: 'Choose this delivery',
    onlyShelves:
      'The package contains items that can not be put in the pickup box',
    pickupboxIsInactive: 'Pickupbox is inactive. Feature unavailable',
    youReservationPinCode: 'You reservation Pin Code',
    wantResendSMS: 'Are you sure you want to resend the SMS?',
    enoughPermissions: 'You do not have enough permissions',
    noContent: 'NO CONTENT.',
    locationNotAllowed: 'LOCATION NOT ALLOWED',
    noSpaceInPickupBoxes: 'No space in pickup boxes',
    descriptionServiceRequest: 'Description of the service request',
    choosePharmacy: 'Choose pharmacy you want to log in',
    changePharmacy: 'Change Pharmacy',
    placeholderText: 'Select Pharmacy',
    connectionLost: 'Internet connection lost',
    pickUpWithAnotherSSN:
      'I certify that verification that the representative has the correct power of attorney/customer ID on site upon delivery',
    addPhoneNumber: 'Add a phone number to the reservation',
    wrongSSN:
      'This is the wrong SSN for this order, please check ID and verify again',
    verifyDeliveryWithoutSSN: 'Verify delivery',
    cooling: 'Cooling',
    thisPeriod: 'This period',
    otherPeriod: 'Other period',
    prevPeriod: 'Prev. period',
    average: 'Average',
    customersAmount: 'Customers Amount',
    satisfiedCustomersAmount: 'Satisfied Customers Amount',
    compareTo: 'Compare to prev. period',
    allFeedback: 'All Feedback that has left the',
    reaction: 'reaction',
    worstCategory: 'Worst category',
    bestCategory: 'Best category',
    mostDissatisfiedCustomersHours: 'Most dissatisfied customers',
    clock: 'Clock: ',
    generalSatisfaction: 'General Satisfaction',
    customersSatisfaction: 'Customers Satisfaction',
    pickupDeliveries: 'Pick-up deliveries',
    customerFeedback: 'Customer Feedback',
    checkAllTemperatures: 'Check All Temperatures',
    serialNumber: 'Serial number',
    modelName: 'Model name',
    pin: 'PIN',
    editSensor: 'Edit sensor',
    addCommentSensor: 'Add Comment',
    active: 'Active',
    translation: 'Translation',
    totalCustomersVotes: 'Amount of responders: ',
    numberOfUsers: 'Amount of responders',
    position: 'Position',
    title: 'Title',
    titleUpperCase: 'TITLE',
    subtitleUpperCase: 'SUBTITLE',
    advertPhoto: 'Advert Photo',
    photoUpperCase: 'PHOTO',
    screenTimeoutUpperCase: 'SCREEN ANSWERING TIME',
    colorUpperCase: 'COLOR',
    logoPhoto: 'Logo Photo',
    chooseScale: 'Choose the scale',
    chooseColor: 'Choose a color',
    hintTextUpperCase: 'HINT TEXT',
    optionsUpperCase: 'FEEDBACK',
    addOption: 'Add Category',
    theSamePositions: 'These options have the same positions',
    positionIsTaken: 'This position is already taken, select another one',
    multipleOptions: 'Allow multiple response options',
    multipleOptionsUpperCase: 'ALLOW MULTIPLE RESPONSE OPTIONS',
    timeout: 'Answering time',
    doNotSaveOption: 'Do not save this Option',
    addNewOption:
      'You cannot create another Option because there are already three active ones',
    settings: 'Settings Customers Feedback',
    general: 'General',
    options: 'Categories',
    report: 'Text feedback',
    grade: 'Grade',
    contact: 'Contact',
    contactUpperCase: 'CONTACT',
    thanks: 'Thanks page',
    /*backTo*/
    backToUsers: 'Back To Users',
    backToInfoPickupBox: 'Back To Info Pick-up Box',
    backToCustomersFeedback: 'Back to Customers Feedback',
    /*lockers*/
    all: 'All',
    allUpperCase: 'ALL',
    free: 'Free',
    reserved: 'Reserved',
    reservedUpperCase: 'RESERVED',
    reservedTable: ' Reserved',
    reservedText: 'reserved',
    pickupTime: 'Picked Up',
    deleted: 'Deleted',
    destroy: 'Destroyed',
    deletedTable: ' Deleted',
    expired: 'Expired',
    expiredTable: ' Expired',
    notInUse: 'Not in Use',
    fridge: 'Fridge',
    delivered: 'Delivered to location',
    deliveredUpperCase: 'DELIVERED',
    deliveredTable: ' Delivered',
    removed: 'Removed',
    removedTable: ' Removed',
    disabled: 'Disabled',
    cancelled: 'Cancelled',
    cancelledTable: ' Cancelled',
    cancelTime: 'Cancelled',
    lost: 'Lost',
    lostTable: ' Lost',
    lostTime: 'Lost',
    pickedUp: 'Picked Up',
    pickup: 'Picked Up',
    pickedUpUpperCase: 'PICKED UP',
    destroyedUpUpperCase: 'DESTROYED',
    pickedUpTable: ' Picked Up',
    destroyedTable: ' Destroyed',
    destroyed: 'Destroyed',
    auto_destroyed: 'Destroyed',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    semi_large: 'Large',
    noSsn: 'No SSN',
    givenOutUserName: 'Given out user',
    /*capacity Pick-up Box*/
    week: 'Week',
    weekUpperCase: 'WEEK',
    month: 'Month',
    boxTypeUpperCase: 'BOX TYPE',
    capacityUpperCase: 'CAPACITY %',
    averagePickupTimeUpperCase: 'AVERAGE PICK-UP TIME',
    /*edit Pick-up Box*/
    temperatureIntervals: 'Temperature Intervals',
    /*temperatureLog*/
    sensorUpperCase: 'LOCKER-ID/SENSOR',
    startTimeUpperCase: 'START TIME',
    startTime: 'Start time',
    endTimeUpperCase: 'END TIME',
    endTime: 'End time',
    durationUpperCase: 'DURATION',
    minUpperCase: 'MIN °C',
    maxUpperCase: 'MAX °C',
    averageUpperCase: 'AVERAGE °C',
    alarmCommentUpperCase: 'ALARM COMMENT',
    date: 'Date',
    temperature: 'Temperature',
    temperatureMax: 'Max Temperature',
    temperatureMin: 'Min Temperature',
    timestempTemperatures: 'Check temperatures',
    lastCheckedBy: 'Last checked by',
    checkTime: 'Checking time',
    'Box Temperature': 'Box Temperature',
    'Fridge 0-1 Temperature': 'Fridge 0-1 Temperature',
    'Fridge 1-1 Temperature': 'Fridge 1-1 Temperature',
    'Fridge 2-1 Temperature': 'Fridge 2-1 Temperature',
    'Fridge 3-1 Temperature': 'Fridge 3-1 Temperature',
    'Fridge 4-1 Temperature': 'Fridge 4-1 Temperature',
    'Fridge 5-1 Temperature': 'Fridge 5-1 Temperature',
    /*deliveryStatistics*/
    monthUpperCase: 'MONTH',
    yearUpperCase: 'YEAR',
    deliveriesUpperCase: '# DELIVERIES',
    pickupsUpperCase: '# PICKEDUP',
    expiredUpperCase: '# EXPIRED',
    destroyedUpperCase: '# DESTROYED',
    avgPickupTimeUpperCase: '# AVG PICKUPTIME (H)',
    totalUsageUpperCase: '# TOTAL USAGE (%)',
    total: 'Total',
    cancelledUpperCase: '# CANCELED',
    hoursUpperCase: 'Hours',
    avgPickupTime: 'AVG PICK-UP TIME',
    /*page*/
    pharmacy: 'Pharmacy',
    profile: 'My Information',
    pickupBox: 'Pick-up Box',
    pickupBoxes: 'Pick-up Boxes',
    sensors: 'Sensors',
    customersFeedback: 'Customers Feedback',
    customersSatisfactionReport: 'Customers Satisfaction Report',
    statistics: 'Statistics',
    users: 'Users',
    user: 'User',
    mainUser: 'Main user',
    userGuide: 'User Guide',
    pharmacyInformation: 'Pharmacy Information',
    lockers: 'Lockers',
    order: 'Order',
    infoPickupBox: 'Pick-up Box Info',
    boxInfo: 'Box Info',
    editPickupBox: 'Edit Pick-up Box',
    reservations: 'Reservations',
    apiReservations: 'API Reservations',
    deliveryHistory: 'Delivery History',
    temperatureLog: 'Temperature Log',
    alarms: 'Alarms',
    capacity: 'Capacity',
    deliveryStatistics: 'Delivery Statistics',
    reserveLocker: 'Reserve Locker'
  },
  fi: {
    account: 'Tili',
    login: 'Kirjaudu sisään',
    logout: 'Kirjaudu ulos',
    loginWithMicrosoft: 'Kirjaudu sisään Microsoftilla',
    pleaseWait: 'Ole hyvä ja odota',
    /*errors*/
    error: 'Virhe',
    not_authorized: 'Käyttäjällä ei ole lupaa',
    Unauthorized: 'Käyttäjällä ei ole lupaa',
    user_is_not_admin: 'Käyttäjän on oltava järjestelmänvalvoja',
    user_is_not_found: 'Käyttäjää ei löydy',
    error_login_user_not_found: 'Käyttäjää ei löydy',
    user_not_found: 'Käyttäjää ei löydy',
    user_single_pharmacy: 'Käyttäjällä on vain yksi apteekki',
    pharmacy_not_found: 'Apteekkia ei löydy',
    pickupbox_not_found: 'Pickupboxia ei löydy',
    template_not_found: 'Mallia ei löytynyt',
    alarm_not_found: 'Hälytystä ei löydy',
    delivery_not_found: 'Toimitusta ei löydy',
    delivery_has_no_ssn: 'Toimituksella ei ole ssn-tietoja',
    ssn_mismatch: 'SSN-virhe',
    link_not_found: 'Varmennuslinkkiä ei löytynyt',
    not_enough_permissions: 'Ei tarpeeksi oikeuksia suorittamiseen',
    error_session_expired: 'Istunto päättynyt',
    no_content: 'Ei sisältöä',
    forbidden: 'Apteekkiin pääsy kielletty',
    not_found: 'Käyttäjää ei löydy',
    unknown: 'Tuntematon virhe',
    wrong_pin_code: 'Pin-koodi on väärä',
    wrong_phone_number: 'Puhelinnumero ei vastaa toimitusta',
    kolli_id_mismatch: 'Kolli Id epäsuhta',
    already_has_access: 'Käyttäjällä on jo pääsy nykyiseen apteekkiin',

    user_with_email_does_not_exist:
      'Käyttäjää, jolla on tämä sähköpostiosoite, ei ole olemassa',
    error_login_too_many_attempts:
      'Liian monta kirjautumisyritystä yritä myöhemmin uudelleen',
    error_login_user_not_found_or_wrong_password:
      'Käyttäjää ei löydy tai salasana on väärä',

    newPassword_missing: 'Salasanan vaihto epäonnistui',
    repeatNewPassword_missing: 'Salasanan vaihto epäonnistui',
    oldPassword_missing: 'Vanha salasana puuttuu',
    newPassword_not_matches_repeatedNewPassword:
      'Uusi salasana ei vastaa toistettua uutta salasanaa',
    oldPassword_matches_newPassword: 'Vanha salasana vastaa uutta salasanaa',

    firstName_empty: 'Etunimi on tyhjä',
    lastName_empty: 'Sukunimi on tyhjä',
    email_empty: 'Sähköpostiosoite on tyhjä',
    invalid_role: 'Väärä rooli',
    this_role_is_greater_than_yours: 'Tämä rooli on suurempi kuin sinun',
    email_missing: 'Sähköposti puuttuu',
    firstName_missing: 'Etunimi puuttuu',
    lastName_missing: 'Sukunimi puuttuu',
    appLanguage_missing: 'Sovelluksen kieli puuttuu',
    role_missing: 'Rooli puuttuu',
    pharmacyIds_must_match: 'Apteekkitunnusten on täsmättävä',
    pharmacyId_missing: 'Apteekin tunnus puuttuu',
    webToolAccess_missing: 'Ei pääsyä verkkotyökaluun',
    boxAccess_missing: 'Ei pääsyä laatikkoon',
    roleName_missing: 'Roolin nimi puuttuu',
    role_not_exist: 'Roolia ei ole olemassa',

    name_missing: 'Nimi puuttuu',
    businessId_missing: 'Yritystunnus puuttuu',
    not_valid_strong_auth_value: 'Invalid value strong auth',
    businessId_already_exists: 'Business ID on jo olemassa',
    pharmacy_templateId_missing: 'Apteekkimallin tunnus puuttuu',
    pharmacy_id_missing: 'Apteekin tunnus puuttuu',
    pharmacy_country_missing: 'Apteekin maa puuttuu',
    pharmacy_language_missing: 'Apteekin kieli puuttuu',
    pharmacy_city_missing: 'Apteekin kaupunki puuttuu',
    pharmacy_outdoor_missing: 'Apteekin ulkoalue puuttuu',
    pharmacy_uiLanguages_missing: 'Apteekki UI kielet puuttuvat',
    pharmacy_zipCode_missing: 'Apteekin postinumero puuttuu',
    pharmacy_cardboardType_missing: 'Apteekin pahvityyppi puuttuu',
    pharmacy_already_exists: 'Apteekki on jo olemassa',
    pharmacy_does_not_exist: 'Apteekkia ei ole olemassa',
    not_valid_strong_auth_value_pharmacy_update:
      'Virheellinen apteekkipäivitys vahvalla valtuutusarvolla',
    shelves_are_in_use_cant_change_number: 'Apteekin päivitys epäonnistui',

    pickupbox_templateId_missing: 'Pickupbox-mallin tunnus puuttuu',
    pickupbox_name_missing: 'Pickupboxin nimi puuttuu',
    pickupbox_id_missing: 'Pickupbox-tunnus puuttuu',
    pickupbox_country_missing: 'Pickupboxin maa puuttuu',
    pickupbox_language_missing: 'Pickupbox-kieli puuttuu',
    pickupbox_city_missing: 'Poimintalaatikon kaupunki puuttuu',
    pickupbox_outdoor_missing: 'Poimintalaatikon kaupunki puuttuu',
    pickupbox_uiLanguages_missing:
      'Poimintalaatikon käyttöliittymän kielet puuttuvat',
    pickupbox_zipCode_missing: 'Pickupboxin postinumero puuttuu',
    pickupbox_cardboardType_missing: 'Pickupbox cardboard type puuttuu',
    pickupbox_already_exists: 'Pickupbox on jo olemassa',
    pickupbox__does_not_exist: 'Pickupboxia ei ole olemassa',

    missing_fields: 'Puuttuvat kentät',
    reserved_locker_cannot_be_inactive:
      'Varattu lokero ei voi olla inaktiivinen',
    locker_do_not_exist: 'Lokeroa ei ole olemassa',
    can_not_assign_to_box: 'Toimitusta ei voi osoittaa laatikkoon',

    user_is_logged_in_to_box: 'Käyttäjä on kirjautunut noutolaatikkoon',
    reservation_delivered: 'Varaus toimitettu',
    pickupbox_disabled: 'Noutolaatikko on kytketty pois päältä',
    user_is_logged_in_to_box_not_create_reservation:
      'Käyttäjä kirjoitti kenttään ei luoda varausta',

    pickupbox_disabled_invalid_locker:
      'Poimintalaatikko poistettu käytöstä virheellinen kaappi',
    user_is_logged_in_to_box_invalid_locker:
      'Käyttäjä on kirjautunut virheelliseen noutolaatikkoon',
    invalid_locker: 'Virheellinen lokero',
    locker_already_reserved: 'Lokerikko on jo varattu',
    wrong_delivery_status: 'Väärä toimituksen tila',
    permissions_empty: 'Oikeudet ovat tyhjiä',
    bad_strong_auth_provider:
      'Huono palvelinkonfiguraatio, vahvan todennuksen tarjoajaa ei ole annettu',
    authentication_link_has_expired: 'Tunnistuslinkki on vanhentunut',

    validation: {
      required: 'Tämä kenttä on pakollinen.',
      email: 'Kirjoita voimassa oleva sähköpostiosoite.',
      phoneNumber: 'Puhelinnumeron muoto: +xxxxxxxxxxxx',
      length: 'Tämän kentän tulee olla 6 merkkiä pitkä.'
    },
    /*info*/
    address: 'Osoite',
    languages: 'Kielet',
    versionSW: 'SW Versio',
    temperatureInterval: 'Lämpötilan intervalli',
    temperatureAlarmInterval: 'Lämpötilahälytysväli',
    email: 'Sähköposti',
    emailUpperCase: 'SÄHKÖPOSTI',
    alarmEmail: 'Hälytys sähköposti',
    password: 'Salasana',
    currentPassword: 'Nykyinen salasana',
    newPassword: 'Uusi salasana',
    confirmPassword: 'Vahvista salasana',
    phoneNumber: 'Puhelinnumero',
    pinCode: 'Pin-koodi',
    shelvesNumber: 'Hyllyjen lukumäärä',
    chooseShelf: 'VALITSE HYLLY',
    show: 'näytä',
    showUpperCase: 'Näytä tämä sivu',
    mobilePhone: 'Matkapuhelin',
    mobilePhoneUpperCase: 'MATKAPUHELIN',
    alarmPhoneNumber: 'Hälytyksen Puhelinnumero',
    firstName: 'Etunimi',
    firstNameUpperCase: 'ETUNIMI',
    lastName: 'Sukunimi',
    lastNameUpperCase: 'SUKUNIMI',
    name: 'Nimi',
    nameUpperCase: 'NIMI',
    pharmacyNameUpperCase: 'APTEEKIN NIMI',
    role: 'Rooli',
    roleUpperCase: 'ROOLI',
    keyUpperCase: 'AVAIN',
    key: 'Avain',
    id: 'ID',
    reservationKeepTime: 'Varauksen säilytysaika',
    pickupBoxName: 'Noutolaatikon Nimi',
    pickupBoxId: 'Noutolaatikon Tunnus',
    city: 'Kaupunki',
    country: 'Maa',
    zipCode: 'Postinumero',
    UILanguages: 'UI Kielet',
    defaultLanguages: 'Oletuskielet',
    cardboardType: 'Noutolaatikko Pahvityyppinen',
    userIdUpperCase: 'KÄYTTÄJÄTUNNUS',
    deliveryStatusUpperCase: 'TOIMITUKSEN TILA',
    deliveryStatus: 'Toimituksen tila',
    kolliIDUpperCase: 'KOLLI-ID',
    lockerID: 'Locker-ID',
    lockerIDUpperCase: 'LOCKER-ID',
    lockerIdOrShelfUpperCase: 'LOCKER-ID / PKT',
    lockerIdOrShelf: 'Locker-ID / PKT',
    orderExpired: 'Tilaus vanhentunut',
    orderExpiredUpperCase: 'TILAUS VANHENTUNUT',
    causeOfAlarmUpperCase: 'HÄLYTYKSEN SYY',
    orderID: 'Tilausnumero',
    lang: 'Kieli',
    desktopLang: 'Työpöydän Kieli',
    pharmacyInfo: 'Apteekin tiedot',
    userBoxPin: 'Käyttäjälaatikon PIN-koodi',
    farmacyEntryPin: 'Farmacy Entry Pin',
    oldLogin: 'Vanha kirjautuminen',
    newLogin: 'Uusi kirjautuminen',
    userBoxId: 'Käyttäjälaatikon tunnus',
    pharmacyReservations: 'Apteekkivaraukset',
    lastUpdate: 'Viimeisin Päivitys',
    kolliID: 'Kolli-ID',
    timeReserved: 'Aika Varattu',
    timeDelivery: 'Ajan Toimitus',
    timePickup: 'Aika Nouto',
    timeDelete: 'Aika Poista',
    timeExpired: 'Aika Päättynyt',
    deliveryMadeBy: 'Toimitus Tekijä',
    description: 'Kuvaus',
    comment: 'Kommentti',
    resendSMSCounter: 'Lähetettyjen SMS-viestien määrä:',
    resendSMSTimestamps: 'Viimeisen lähetetyn SMS:n aika:',
    descriptionUpperCase: 'KUVAUS',
    reservationMadeByUpperCase: 'VARAUKSEN TEKEE',
    deliveredByUpperCase: 'TOIMITETTU',
    assignedTimeByUpperCase: 'MÄÄRITETTY AIKAAN',
    assignedTime: 'Määritelty aikaan',
    assignedUserName: 'Määritelty',
    fulfillment_order_id: 'Toimitustilauksen-ID',
    order_id: 'Tilauksen-ID',
    reservedUserName: 'Varauksen tekee',
    pickupboxPageAssignDelivery: 'PICKUPBOX-SIVU ANNA TOIMITUS',
    lastLoginUpperCase: 'VIIMEINEN KIRJAUTUMINEN',
    userUpperCase: 'KÄYTTÄJÄ',
    typeUpperCase: 'TYYPPI',
    assignUpperCase: 'ANNA',
    alarmOk: 'Kaikki on kunnossa kaapin kanssa',
    alarmDoorOpen: 'Kaappi ei sulkeudu',
    alarmDoorClosed: 'Kaappi ei avaudu',
    alarmTempHigh: 'Lokeron lämpötila on korkea',
    alarmTempLow: 'Lokeron lämpötila on alhainen',
    alarmOther: 'Lokerosta ei ole tietoja saatavilla',
    alarmMissing: 'Lokeron tiedot puuttuvat',
    connection_lost: 'Yhteys katkennut',
    january: 'Tammikuu',
    february: 'Helmikuu',
    march: 'Maaliskuu',
    april: 'Huhtikuu',
    may: 'Toukokuu',
    june: 'Kesäkuu',
    july: 'Heinäkuu',
    august: 'Elokuu',
    september: 'Syyskuu',
    october: 'Lokakuu',
    november: 'Marraskuu',
    december: 'Joulukuu',
    roomTemp: 'Huoneen lämpötila',
    includesDrug: 'Sisältää lääkkeen',
    includesDrugUpperCase: 'SISÄLTÄÄ LÄÄKKEEN',
    narcoticsUpperCase: 'HUUMEET',
    log: 'Tukki',
    min: 'minuutti',
    minute: ' minuutti',
    minutes: ' minuuttia',
    hour: 'tunti',
    hours: 'tuntia',
    day: ' päivä',
    days: ' päivät',
    daysDelivery: 'Päivät',
    basicLocker: 'Peruslokero:',
    fridgeLocker: 'Jääkaapin lukko:',
    deliveryExpirationTime: 'Toimituksen vanhenemisaika',
    reminderMessageTime: 'Muistutusviestin aika',
    reservationExpirationTime: 'Varauksen vanhenemisaika',
    fullHistory: 'Koko historia',
    /*actions*/
    forgotPassword: 'Unohtuiko Іalasana?',
    sendResetLink: 'Lähetä nollauslinkki',
    backToLogIn: 'Takaisin Sisäänkirjautumiseen',
    sentEmail: 'Salasanan palautusviesti lähetetty.',
    edit: 'Muokata',
    add: 'Lisätä',
    chooseLanguage: 'Valitse tekstiviestien kielet',
    save: 'Tallentaa',
    delete: 'Poistaa',
    cancel: 'Peruuttaa',
    cleanFields: 'Puhtaat kentät',
    search: 'Hae',
    makeServiceRequest: 'Tee palvelupyyntö',
    seriviceRequested: 'Palvelua pyydettiin',
    referToHelpdesk: 'Tutustu neuvontapalveluumme',
    addUser: 'Lisää Käyttäjä',
    removeFromMyPharmacy: 'Poista apteekistani',
    loginInformation: 'Sisäänkirjautumistiedot',
    selectMultipleLockers: 'Valitse Useita lokeroita',
    chooseSeveralShelves: 'Valitse useita hyllyjä',
    disableLocker: 'Poista Locker käytöstä',
    locker: 'Kaappi',
    reservation: 'Varaukset',
    delivery: 'Toimitus',
    deleteReservation: 'Poista varaus',
    reserve: 'Varata',
    newBookingPharmacyPickup: 'Uusi varaus apteekin noutoa varten',
    exportJSON: 'Viedä.json',
    importJSON: 'Tuonti.json',
    downloadCSV: 'Ladata.csv',
    downloadTempCSV: 'Lataa lämpötilat.csv',
    downloadPDF: 'Ladata.pdf',
    createReservation: 'Luo Varaus',
    webToolAccess: 'Pääsy web-työkaluun',
    boxAccess: 'Pääsy laatikkoon',
    ok: 'Ok',
    happy: 'Tyytyväinen',
    angry: 'Tyytymätön',
    yes: 'Joo',
    no: 'Ei',
    noTable: 'Ei',
    and: 'ja',
    verifySSN: 'Tarkista SSN',
    pickupForAnotherSSN: 'Toisen SSN:n hakeminen',
    assignReservation: 'Noutolaatikko -sivu Tee varaus',
    redirectToPickupBox: 'Ohjaa PickupBoxiin',
    quickReservation: 'Nopea varaus',
    quickReservationLockers: 'Nopea manuaalinen varaus',
    isDrug: 'Lääke sisältää',
    drug: 'Lääke',
    ssn: 'SSN',
    ssnPickUp: 'Nouto SSN',
    ssnForOtherPerson: 'Noutajan SSN-tunnus',
    resendSMS: 'Lähetä SMS uudelleen',
    showFullHistory: 'Näytä koko historia',
    hideFullHistory: 'Piilota koko historia',
    /*text*/
    pageNotFound: 'Sivua Ei Löydetty',
    checkURL:
      'Määritettyä tiedostoa ei löytynyt tältä sivustolta. Tarkista URL-osoite virheiden varalta ja yritä uudelleen.',
    forgotPasswordTex:
      'Anna sähköpostiosoitteesi, niin lähetämme sinulle sähköpostin. Sähköpostissa olevaa linkkiä seuraamalla pääset syöttämään uuden salasanasi.',
    passwordCharacters: 'Salasanan tulee sisältää vähintään 8 merkkiä.',
    youWantDelete: 'Haluatko varmasti poistaa',
    descriptionDestroy:
      'Tuhottu – Siirrä varaus historiaan. Tämä tehdään tuhoamisen yhteydessä.',
    descriptionDelete:
      'Poistaa – Siirrä varaus takaisin "API-varaukset" -välilehdelle, eli peru varausta varataksesi uuden ajan.',

    descriptionCancel: 'Peruuttaa - Sulje ikkuna ilman toimenpidettä.',
    youWantDeleteReservation:
      'Haluatko varmasti poistaa tämän varauksen? Tätä muutosta ei voi kumota',
    undone: '? Tätä muutosta ei voi kumota.',
    changePasswordInfo:
      'INFO: Muista salasana ja anna se käyttäjälle. Et voi palauttaa salasanaa myöhemmin. Salasanan tulee sisältää vähintään 8 merkkiä.',
    noPickupBox: 'Ei Noutolaatikkoa',
    noFeedback: 'Ei palautetta',
    addDescription: 'Lisää kuvaus toimitushistoriaan',
    infoReservation: 'Tietoa varauksesta',
    addAlarmComment: 'Lisää hälytyskommentti',
    deviationsInTimeFrame: 'Poikkeamat aikarajoissa',
    addUserMainInfo:
      'INFO: Muista salasana ja anna se käyttäjälle. Et voi palauttaa salasanaa myöhemmin.',
    addUserInfo: 'Salasanan tulee sisältää vähintään 8 merkkiä.',
    lockersSelected: 'kaapit on valittu',
    messageTemperatureHigh: 'Lokeron lämpötila on liian korkea: ',
    messageTemperatureLow: 'Lokeron lämpötila on liian alhainen: ',
    noData: 'Ei dataa',
    errorDate: 'Virhepäivämäärä',
    noReservations: 'Ei varauksia',
    noOrderReservedYet: 'Tilausta ei ole vielä varattu',
    enableLocker:
      'Tilausta ei ole vielä varattu. Ota Locker käyttöön tilausten varaamiseksi.',
    noAlarms: 'Ei hälytyksiä valitun ajanjakson aikana',
    assignDeliveryFromDesk: 'Määritä toimitus noudettavaksi pöydältä',
    updateDelivery: 'Päivityksen toimitus',
    assignDeliveryFromLocker: 'Määritä toimitus noudettavaksi noutolaatikosta',
    assignToLocker:
      'Jos haluat, että tämä toimitus noudetaan Nouto! -laatikosta, paina "Ohjaa PickupBoxiin" -painiketta. Napsauta vapaata paikkaa ja valitse "Noutolaatikko -sivu Tee varaus".',
    pickedUpRevervation: 'Onko varaus noudettu?',
    chooseDelivery: 'Valitse toimitus luettelosta',
    chooseThisDelivery: 'Valitse tämä toimitus',
    onlyShelves:
      'Paketti sisältää tuotteita, joita ei saa jättää noutopisteeseen',
    pickupboxIsInactive:
      'Pickupbox ei ole aktiivinen. Ominaisuus ei ole käytettävissä',
    youReservationPinCode: 'Teidän varauksenne Pin-koodi',
    wantResendSMS: 'Haluatko varmasti lähettää tekstiviestin uudelleen?',
    enoughPermissions: 'Sinulla ei ole tarpeeksi oikeuksia',
    noContent: 'EI SISÄLTÖÄ.',
    locationNotAllowed: 'SIJAINTI EI SALLITTU',
    noSpaceInPickupBoxes: 'Noutolaatikoissa ei ole tilaa',
    descriptionServiceRequest: 'Palvelupyynnön kuvaus',
    choosePharmacy: 'Valitse apteekki, johon haluat kirjautua',
    changePharmacy: 'Vaihda Apteekki',
    placeholderText: 'Valitse Apteekki',
    connectionLost: 'Internet-yhteys katkesi',
    pickUpWithAnotherSSN:
      'Vakuutan, että edustajalla on oikeat valtakirjat/asiakastunnukset paikalla toimituksen yhteydessä',
    addPhoneNumber: 'Lisää puhelinnumero varaukseen',
    wrongSSN:
      'Tämä on väärä SSN tätä tilausta varten, tarkista henkilöllisyystodistus ja tarkista uudelleen',
    verifyDeliveryWithoutSSN: 'Tarkista toimitus',
    cooling: 'Jäähdytys',
    thisPeriod: 'Tämä jakso',
    otherPeriod: 'Muu jakso',
    prevPeriod: 'Edellinen jakso',
    average: 'Keskimääräinen',
    customersAmount: 'Asiakkaiden Määrä',
    satisfiedCustomersAmount: 'Tyytyväisten Asiakkaiden Määrä',
    compareTo: 'Edelliseen jaksoon verrattuna',
    allFeedback: 'Kaikki palautteet, jotka on jätetty',
    reaction: 'reaktio',
    worstCategory: 'Huonoin kategoria',
    bestCategory: 'Paras kategoria',
    mostDissatisfiedCustomersHours: 'Tyytymättömimmät asiakkaat',
    clock: 'Kello: ',
    generalSatisfaction: 'Yleinen tyytyväisyys',
    customersSatisfaction: 'Asiakastyytyväisyys',
    pickupDeliveries: 'Noutotilaukset',
    customerFeedback: 'Asiakaspalaute',
    checkAllTemperatures: 'Tarkista kaikki lämpötilat',
    serialNumber: 'Sarjanumero',
    modelName: 'Mallin nimi',
    pin: 'PIN-koodi',
    editSensor: 'Muokkaa anturia',
    addCommentSensor: 'Lisää kommentti',
    active: 'Aktiivinen',
    translation: 'Käännös',
    totalCustomersVotes: 'Vastaajien määrä: ',
    numberOfUsers: 'Vastaajien määrä',
    position: 'Asema',
    title: 'Titteli',
    titleUpperCase: 'NIMIKE',
    subtitleUpperCase: 'ALATYYPPI',
    advertPhoto: 'Mainoskuva',
    photoUpperCase: 'KUVA',
    screenTimeoutUpperCase: 'NÄYTÖN VASTAUSAIKA',
    colorUpperCase: 'VÄRI',
    logoPhoto: 'Logokuva',
    chooseScale: 'Valitse mittakaava',
    chooseColor: 'Valitse väri',
    hintTextUpperCase: 'VINKKITEKSTI',
    optionsUpperCase: 'PALAUTE',
    addOption: 'Lisää kategoria',
    multipleOptions: 'Salli useat vastausvaihtoehdot',
    multipleOptionsUpperCase: 'SALLI USEAT VASTAUSVAIHTOEHDOT',
    timeout: 'Vastausaika',
    addNewOption:
      'Et voi luoda uutta vaihtoehtoa, koska käytössä on jo kolme aktiivista vaihtoehtoa',
    theSamePositions: 'Näillä vaihtoehdoilla on samat kannat',
    positionIsTaken: 'Tämä asema on jo varattu, valitse toinen',
    doNotSaveOption: 'Älä tallenna tätä vaihtoehtoa',
    settings: 'Asiakaspalautteiden asetukset',
    general: 'Yleistä',
    options: 'Kategoriat',
    report: 'Kirjallinen palaute',
    grade: 'Arvosana',
    contact: 'Ota yhteyttä',
    contactUpperCase: 'YHTEYSTIEDOT',
    thanks: 'Kiitossivu',
    /*backTo*/
    backToUsers: 'Takaisin Käyttäjiin',
    backToInfoPickupBox: 'Takaisin tietoihin Noutolaatikko',
    backToCustomersFeedback: 'Takaisin asiakaspalautteeseen',
    /*lockers*/
    all: 'Kaikki',
    allUpperCase: 'KAIKKI',
    free: 'Vapaa',
    reserved: 'Varattu',
    reservedUpperCase: 'VARATTU',
    reservedTable: ' Varattu',
    reservedText: 'varattu',
    pickupTime: 'Noudettu',
    deleted: 'Poistettu',
    deletedTable: ' Poistettu',
    expired: 'Vanhentunut',
    expiredTable: ' Vanhentunut',
    notInUse: 'Ei Käytössä',
    fridge: 'Jääkaappi',
    delivered: 'Toimitetaan paikalle',
    deliveredUpperCase: 'TOIMITETTU',
    deliveredTable: ' Toimitettu',
    removed: 'Poistettu',
    removedTable: ' Poistettu',
    disabled: 'Liikuntarajoitteinen',
    cancelled: 'Peruutettu',
    cancelledTable: ' Peruutettu',
    cancelTime: 'Peruutettu',
    lost: 'Kadonnut',
    lostTable: ' Kadonnut',
    lostTime: 'Kadonnut',
    pickedUp: 'Poimittu',
    pickup: 'Poimittu',
    pickedUpUpperCase: 'POIMITTU',
    destroyedUpUpperCase: 'TUHOTTU',
    pickedUpTable: ' Poimittu',
    destroyedTable: ' Tuhottu',
    destroyed: 'Tuhottu',
    auto_destroyed: 'Tuhottu',
    small: 'Pieni',
    medium: 'Keskikokoinen',
    large: 'Suuri',
    semi_large: 'Suuri',
    noSsn: 'Ei SSN',
    givenOutUserName: 'Annettu käyttäjälle',
    /*capacity Pick-up Box*/
    week: 'Viikko',
    weekUpperCase: 'VIIKKO',
    month: 'Kuukausi',
    boxTypeUpperCase: 'LAATIKKO TYYPPI',
    capacityUpperCase: 'KAPASITEETTI %',
    averagePickupTimeUpperCase: 'KESKIMÄÄRÄINEN NUOTOAIKA',
    /*edit Pick-up Box*/
    temperatureIntervals: 'Lämpötilavälit',
    /*temperatureLog*/
    sensorUpperCase: 'LOCKER-ID/SENSORI',
    startTimeUpperCase: 'ALOITUSAIKA',
    startTime: 'Aloitusaika',
    endTimeUpperCase: 'LOPPUAIKA',
    endTime: 'Loppu aika',
    durationUpperCase: 'KESTO',
    minUpperCase: 'MIN °C',
    maxUpperCase: 'MAX °C',
    averageUpperCase: 'KESKIVERTO °C',
    alarmCommentUpperCase: 'HÄLYTYKOMMENTTI',
    date: 'Päivämäärä',
    temperature: 'Lämpötila',
    temperatureMax: 'Max Lämpötila',
    temperatureMin: 'Min Lämpötila',
    timestempTemperatures: 'Tarkista lämpötilat',
    lastCheckedBy: 'Viimeksi tarkistanut',
    checkTime: 'Tarkistusaika',
    'Box Temperature': 'Laatikoston lämpötila',
    'Fridge 0-1 Temperature': 'Jääkaappi 0-1 Lämpötila',
    'Fridge 1-1 Temperature': 'Jääkaappi 1-1 Lämpötila',
    'Fridge 2-1 Temperature': 'Jääkaappi 2-1 Lämpötila',
    'Fridge 3-1 Temperature': 'Jääkaappi 3-1 Lämpötila',
    'Fridge 4-1 Temperature': 'Jääkaappi 4-1 Lämpötila',
    'Fridge 5-1 Temperature': 'Jääkaappi 5-1 Lämpötila',
    /*deliveryStatistics*/
    monthUpperCase: 'KUUKAUSI',
    yearUpperCase: 'VUOSI',
    deliveriesUpperCase: '# TOIMITUKSET',
    pickupsUpperCase: '# NOUDAT',
    expiredUpperCase: '# VANHENTUNUT',
    destroyedUpperCase: '# TUHOTUT',
    avgPickupTimeUpperCase: '# AVG NOUTOAIKA (T)',
    totalUsageUpperCase: '# KÄYTTÖ YHTEENSÄ (%)',
    total: 'Käyttö',
    cancelledUpperCase: '# PERUUTETTU',
    averagePickupTime: 'AVG Noutoaika',
    hoursUpperCase: 'Tunnit',
    avgPickupTime: 'KESKIMÄÄRÄINEN NUOTOAIKA',
    /*page*/
    pharmacy: 'Apteekki',
    profile: 'Minun tietoni',
    pickupBox: 'Noutolaatikko',
    pickupBoxes: 'Noutolaatikot',
    sensors: 'Anturit',
    customersFeedback: 'Asiakaspalaute',
    customersSatisfactionReport: 'Asiakastyytyväisyysraportti',
    statistics: 'Tilastot',
    users: 'Käyttäjät',
    user: 'Käyttäjä',
    mainUser: 'Pääkäyttäjä',
    userGuide: 'Käyttöohjeet',
    pharmacyInformation: 'Apteekin Tiedot',
    lockers: 'Kaapit',
    order: 'Tilaus',
    infoPickupBox: 'Noutolaatikon Tiedot',
    boxInfo: 'Laatikon Tiedot',
    editPickupBox: 'Muokkaa Noutolaatikkoa',
    reservations: 'Varaukset',
    apiReservations: 'API-varaukset',
    deliveryHistory: 'Toimitushistoria',
    temperatureLog: 'Lämpötilaloki',
    alarms: 'Hälytykset',
    capacity: 'Kapasiteetti',
    deliveryStatistics: 'Toimitustilastot',
    reserveLocker: 'Reserve Locker'
  },
  sv: {
    account: 'Konto',
    login: 'Logga in',
    logout: 'Logga ut',
    loginWithMicrosoft: 'Logga in med Microsoft',
    pleaseWait: 'Vänligen vänta',
    /*errors*/
    error: 'Fel',
    not_authorized: 'Användaren är inte auktoriserad',
    Unauthorized: 'Användaren är inte auktoriserad',
    user_is_not_admin: 'Användaren måste vara administratör',
    user_is_not_found: 'Användaren har inte hittats',
    error_login_user_not_found: 'Användaren hittades inte',
    user_not_found: 'Användaren hittas ej',
    user_single_pharmacy: 'Användaren har endast ett apotek',
    pharmacy_not_found: 'Apotek hittades inte',
    pickupbox_not_found: 'Pickupbox hittades inte',
    template_not_found: 'Mall hittades inte',
    alarm_not_found: 'Larm hittades inte',
    delivery_not_found: 'Leverans hittades inte',
    delivery_has_no_ssn: 'Leverans har ingen ssn-data',
    ssn_mismatch: 'SSN-missmatchning',
    link_not_found: 'Verifieringslänk hittades inte',
    not_enough_permissions: 'Inte tillräckligt med behörigheter för att utföra',
    error_session_expired: 'Sessionen har löpt ut',
    no_content: 'Inget innehåll',
    forbidden: 'Åtkomst till apotek nekad',
    not_found: 'Användaren hittades inte',
    unknown: 'Okänt fel',
    wrong_pin_code: 'Pin-koden är felaktig',
    wrong_phone_number: 'Telefonnumret stämmer inte överens med leveransen',
    kolli_id_mismatch: 'Kolli Id-missmatchning',
    already_has_access: 'Användaren har redan tillgång till aktuellt apotek',

    user_with_email_does_not_exist:
      'Användare med denna e-postadress finns inte',
    error_login_too_many_attempts:
      'För många inloggningsförsök, försök igen senare',
    error_login_user_not_found_or_wrong_password:
      'Användaren hittades inte eller fel lösenord',
    firebase_wrong_password:
      'Firebase: The password is invalid or the user does not have a password. (auth/wrong-password).',

    newPassword_missing: 'Lösenordsändring misslyckades',
    repeatNewPassword_missing: 'Lösenordsändring misslyckades',
    oldPassword_missing: 'Gammalt lösenord saknas',
    newPassword_not_matches_repeatedNewPassword:
      'Det nya lösenordet matchar inte det upprepade nya lösenordet',
    oldPassword_matches_newPassword:
      'Det gamla lösenordet matchar det nya lösenordet',

    firstName_empty: 'Förnamnet är tomt',
    lastName_empty: 'Efternamnet är tomt',
    email_empty: 'E-postadressen är tom',
    invalid_role: 'Fel roll',
    this_role_is_greater_than_yours: 'Den här rollen är större än din',
    email_missing: 'E-post saknas',
    firstName_missing: 'Förnamn saknas',
    lastName_missing: 'Efternamn saknas',
    appLanguage_missing: 'Appens språk saknas.',
    role_missing: 'Roll saknas',
    pharmacyIds_must_match: 'Apotekets ID måste matcha',

    pharmacyId_missing: 'Apoteks-ID saknas',
    webToolAccess_missing: 'Ingen tillgång till webbverktyget',
    boxAccess_missing: 'Ingen åtkomst till boxen',
    roleName_missing: 'Rollnamn saknas',
    role_not_exist: 'Rollen existerar inte',

    name_missing: 'Namn saknas',
    businessId_missing: 'Företags-ID saknas',
    not_valid_strong_auth_value: 'Ogiltigt värde strong auth',
    businessId_already_exists: 'Företagets ID finns redan',
    pharmacy_templateId_missing: 'Apoteksmallens ID saknas',
    pharmacy_id_missing: 'Apotekets ID saknas',
    pharmacy_country_missing: 'Apotekets land saknas',
    pharmacy_language_missing: 'Apotekets språk saknas',
    pharmacy_city_missing: 'Apotekets stad saknas',
    pharmacy_outdoor_missing: 'Apotekets utomhusområde saknas',
    pharmacy_uiLanguages_missing: 'Apotekets UI-språk saknas',
    pharmacy_zipCode_missing: 'Postnummer för apotek saknas',
    pharmacy_cardboardType_missing: 'Kartongtyp för apotek saknas',
    pharmacy_already_exists: 'Apoteket finns redan',
    pharmacy_does_not_exist: 'Inget apotek finns',
    not_valid_strong_auth_value_pharmacy_update:
      'Ogiltig apoteksuppdatering med ett starkt auktoriseringsvärde',
    shelves_are_in_use_cant_change_number: 'Uppdatering av apotek misslyckades',

    pickupbox_templateId_missing: 'ID för mall för pickupbox saknas',
    pickupbox_name_missing: 'Pickupboxens namn saknas',
    pickupbox_id_missing: 'Pickupbox ID saknas',
    pickupbox_country_missing: 'Pickupboxens land saknas',
    pickupbox_language_missing: 'Pickupboxens språk saknas',
    pickupbox_city_missing: 'Pickupbox stad saknas',
    pickupbox_outdoor_missing: 'Pickupbox utomhus saknas',
    pickupbox_uiLanguages_missing: 'Pickupbox UI språk saknas',
    pickupbox_zipCode_missing: 'Postnummer för pickupbox saknas',
    pickupbox_cardboardType_missing: 'Kartongtyp för pickupbox saknas',
    pickupbox_already_exists: 'Pickupbox finns redan',
    pickupbox__does_not_exist: 'Ingen pickupbox finns',

    missing_fields: 'Saknade fält',
    reserved_locker_cannot_be_inactive:
      'Ett reserverat skåp kan inte vara inaktivt',
    locker_do_not_exist: 'Skåpet existerar inte',
    can_not_assign_to_box: 'Leveransen kan inte tilldelas boxen',

    user_is_logged_in_to_box: 'Användaren är inloggad på brevlådan',
    reservation_delivered: 'Bokning levererad',
    pickupbox_disabled: 'Pickupboxen är avstängd',
    user_is_logged_in_to_box_not_create_reservation:
      'Användaren gick in i fältet för att inte skapa en reservation',

    pickupbox_disabled_invalid_locker: 'Pickupboxen inaktiverad ogiltigt skåp',
    user_is_logged_in_to_box_invalid_locker:
      'Användaren är inloggad på en ogiltig brevlåda',
    invalid_locker: 'Ogiltigt skåp',
    locker_already_reserved: 'Skåpet är redan reserverat',
    wrong_delivery_status: 'Felaktig leveransstatus',
    permissions_empty: 'Behörigheterna är tomma',
    bad_strong_auth_provider:
      'Dålig serverkonfiguration, ingen leverantör för stark autentisering angiven',
    authentication_link_has_expired: 'Autentiseringslänken har gått ut',

    validation: {
      required: 'Du måste välja hyllplats.',
      email: 'Vänligen ange en giltig e-postadress.',
      phoneNumber: 'Format för telefonnummer: +xxxxxxxxxxxx',
      length: 'Detta fält ska vara 6 tecken långt.'
    },
    /*info*/
    address: 'Adress',
    languages: 'Språk',
    versionSW: 'Mjukvaruversion',
    temperatureInterval: 'Temperaturintervall',
    temperatureAlarmInterval: 'Temperaturlarmintervall',
    email: 'E-post',
    emailUpperCase: 'E-POST',
    alarmEmail: 'E-post för larm',
    password: 'Lösenord',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    phoneNumber: 'Telefonnummer',
    pinCode: 'Pin-kod',
    shelvesNumber: 'Antal hyllor',
    chooseShelf: 'VÄLJ HYLLA',
    show: 'visa',
    showUpperCase: 'Visa denna sida',
    mobilePhone: 'Mobiltelefon',
    mobilePhoneUpperCase: 'MOBILTELEFON',
    alarmPhoneNumber: 'Telefonnummer för larm',
    firstName: 'Förnamn',
    firstNameUpperCase: 'FÖRNAMN',
    lastName: 'Efternamn',
    lastNameUpperCase: 'EFTERNAMN',
    name: 'Namn',
    nameUpperCase: 'NAMN',
    pharmacyNameUpperCase: 'APOTEKETS NAMN',
    role: 'Användarroll',
    roleUpperCase: 'ANVÄNDARROLL',
    keyUpperCase: 'NYCKEL',
    key: 'Nyckel',
    id: 'ID',
    reservationKeepTime: 'Bokningens varaktighet',
    pickupBoxName: 'Pickupboxens namn',
    pickupBoxId: 'Pickupboxens ID',
    city: 'Stad',
    country: 'Land',
    zipCode: 'Postnummer',
    UILanguages: 'Användargränssnitsspråk',
    defaultLanguages: 'Standardspråk',
    cardboardType: 'Upphämtningslådans korttyp',
    userIdUpperCase: 'ANVÄNDAR ID',
    deliveryStatusUpperCase: 'LEVERANSSTATUS',
    deliveryStatus: 'Leveransstatus',
    kolliIDUpperCase: 'KOLLI-ID',
    lockerID: 'Box-ID',
    lockerIDUpperCase: 'BOX-ID',
    lockerIdOrShelfUpperCase: 'BOX-ID / PKT',
    lockerIdOrShelf: 'Box-ID / PKT',
    orderExpired: 'Beställning har gått ut',
    orderExpiredUpperCase: 'BESTÄLLNING GICK UT',
    causeOfAlarmUpperCase: 'ORSAK TILL LARM',
    orderID: 'Kolli-ID',
    lang: 'Språk',
    desktopLang: 'Skrivbordsspråk',
    pharmacyInfo: 'Apotek Info',
    userBoxPin: 'PIN-kod',
    farmacyEntryPin: 'Användarnamn',
    oldLogin: 'Gammal inloggning',
    newLogin: 'Ny inloggning',
    userBoxId: 'Användarbox-ID',
    pharmacyReservations: 'Apoteksbokningar',
    lastUpdate: 'Senaste uppdateringen',
    kolliID: 'Kolli-ID',
    timeReserved: 'Reservationstid',
    timeDelivery: 'Tidsbestämd Leverans',
    timePickup: 'Tid för Upphämtning',
    timeDelete: 'Tid för Borttagning',
    timeExpired: 'Tid Passerad',
    deliveryMadeBy: 'Levererad av',
    description: 'Beskrivning',
    descriptionUpperCase: 'BESKRIVNING',
    comment: 'Kommentar',
    resendSMSCounter: 'Antal skickade SMS:',
    resendSMSTimestamps: 'Tidpunkt för senast skickat SMS:',
    reservationMadeByUpperCase: 'BOKAD AV',
    deliveredByUpperCase: 'LEVERERAD AV',
    assignedTimeByUpperCase: 'TILLDELAD VID',
    assignedTime: 'Tilldelad vid',
    assignedUserName: 'Tilldelad',
    fulfillment_order_id: 'Uppfyllningsorder-ID',
    order_id: 'Order-ID',
    reservedUserName: 'Bokad av',
    pickupboxPageAssignDelivery: 'PICKUPBOXSIDA TILLDELA LEVERANS',
    lastLoginUpperCase: 'SENASTE INLOGGNING',
    userUpperCase: 'ANVÄNDARE',
    typeUpperCase: 'TYP',
    assignUpperCase: 'TILLDELA',
    alarmOk: 'Boxstatus ok',
    alarmDoorOpen: 'Luckan stängs inte',
    alarmDoorClosed: 'Luckan öppnas inte',
    alarmTempHigh: 'Temperaturen i skåpet är hög',
    alarmTempLow: 'Temperaturen i skåpet är låg',
    alarmOther: 'Inga uppgifter om skåpet finns tillgängliga',
    alarmMissing: 'Uppgifter om skåpet saknas',
    connection_lost: 'Anslutningen förlorad',
    january: 'Januari',
    february: 'Februari',
    march: 'Mars',
    april: 'April',
    may: 'Maj',
    june: 'Juni',
    july: 'Juli',
    august: 'Augusti',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'December',
    roomTemp: 'Rumstemperatur',
    includesDrug: 'Förskrivna läkemedel',
    includesDrugUpperCase: 'FÖRSKRIVNA LÄKEMEDEL',
    narcoticsUpperCase: 'NARKOTIKA',
    log: 'Logg',
    min: 'minut',
    minute: ' minut',
    minutes: ' minuter',
    hour: 'timme',
    hours: 'timmar',
    day: ' dag',
    days: ' dagar',
    daysDelivery: 'Dagar',
    basicLocker: 'Lucka:',
    fridgeLocker: 'Kyld lucka:',
    deliveryExpirationTime: 'Leverans utgångstid',
    reminderMessageTime: 'Påminnelse SMS',
    reservationExpirationTime: 'Reservationens utgångstid',
    fullHistory: 'Fullständig historik',
    /*actions*/
    forgotPassword: 'Glömt ditt lösenord?',
    sendResetLink: 'Skicka återställningslänk för lösenord',
    backToLogIn: 'Tillbaka till inloggning',
    sentEmail: 'E-postmeddelande om lösenordsåterställning har skickats.',
    edit: 'Redigera',
    add: 'Lägg till',
    chooseLanguage: 'Välj språk för SMS',
    save: 'Bekräfta',
    delete: 'Radera',
    cancel: 'Avbryt',
    cleanFields: 'Töm fält',
    search: 'Sök',
    makeServiceRequest: 'Gör en servicebegäran',
    seriviceRequested: 'Service begärd',
    referToHelpdesk: 'Kontakta Helpdesk',
    addUser: 'Lägg till användare',
    removeFromMyPharmacy: 'Ta bort från mitt apotek',
    loginInformation: 'Inloggningsinformation',
    selectMultipleLockers: 'Välj flera luckor',
    chooseSeveralShelves: 'Välj flera hyllor',
    disableLocker: 'Inaktivera lucka',
    locker: 'Lucka',
    reservation: 'Bokning',
    delivery: 'Leverans',
    deleteReservation: 'Radera bokning',
    reserve: 'Boka',
    newBookingPharmacyPickup: 'Ny bokning för avhämtning av apotek',
    exportJSON: 'Exportera.json',
    importJSON: 'Importera.json',
    downloadCSV: 'Ladda ner.csv',
    downloadTempCSV: 'Ladda ner temperaturer.csv',
    downloadPDF: 'Ladda.pdf',
    createReservation: 'Gör en bokning',
    webToolAccess: 'Tillgång till Webtool',
    boxAccess: 'Tillgång till box',
    ok: 'Ok',
    happy: 'Lycklig',
    angry: 'Arg',
    yes: 'Ja',
    no: 'Avbryt',
    noTable: 'Nej',
    and: 'och',
    verifySSN: 'ID-kontroll',
    pickupForAnotherSSN: 'Ombud/Fullmakt',
    verify: 'Utlämning utan personnummer',
    assignReservation: 'Tilldela bokning',
    redirectToPickupBox: 'Till Pickupbox',
    quickReservation: 'Snabbokning',
    quickReservationLockers: 'Manuell snabbokning',
    isDrug: 'Innehåller förskrivet',
    drug: 'Läkemedel',
    ssn: 'ID/personnummer kunden',
    ssnPickUp: 'Plocka upp SSN',
    ssnForOtherPerson: 'ID/personnummer för ombud/fullmaktsperson',
    resendSMS: 'Skicka SMS på nytt',
    showFullHistory: 'Visa hela historiken',
    hideFullHistory: 'Dölj hela historiken',
    /*text*/
    pageNotFound: 'Sidan hittas ej',
    checkURL:
      'Den angivna filen hittades inte på denna webbplats. Kontrollera webbadressen och försök igen.',
    forgotPasswordTex:
      'Vänligen ange din e-postadress så skickar vi ett e-postmeddelande. Genom att följa länken i mejlet kommer du att kunna ange ditt nya lösenord.',
    passwordCharacters: 'Lösenordet bör innehålla minst 8 tecken.',
    youWantDelete: 'Är du säker att du vill radera?',
    descriptionDestroy:
      'Förstör – Flytta reservationen till historik, detta är att likställa med ”Destruera” i Viskan. Dvs skall användas när ni gör destruering.',
    descriptionDelete:
      'Radera – Flytta tillbaka reservationen till fliken ”viskan bokningar” dvs avbryt reservationen till box för att reservera ny lucka.',
    descriptionCancel: 'Avbryt – Stäng fönster utan åtgärd',

    youWantDeleteReservation:
      'Är du säker på att du vill ta bort denna reservation? Denna ändring kan inte ångras.',
    undone: '? Denna ändring kan inte ångras.',
    changePasswordInfo:
      'INFO: Memorera lösenordet och lämna över det till användaren. Du kan inte återställa lösenordet senare. Lösenordet bör innehålla minst 8 tecken.',
    noPickupBox: 'Ingen pickupbox',
    noFeedback: 'Ingen feedback',
    addDescription: 'Lägg till beskrivning till leveranshistorik',
    infoReservation: 'Information om reservationen',
    addAlarmComment: 'Lägg till larmkommentar',
    deviationsInTimeFrame: 'Avvikelser i tidsram',
    addUserMainInfo:
      'INFO: Memorera lösenordet och lämna över det till användaren. Du kan inte återställa lösenordet senare.',
    addUserInfo: 'Lösenordet bör innehålla minst 8 tecken.',
    lockersSelected: 'luckor är valda',
    messageTemperatureHigh: 'Skåpets temperatur är för hög: ',
    messageTemperatureLow: 'Skåpets temperatur är för låg: ',
    noData: 'Ingen data',
    errorDate: 'Feldatum',
    noReservations: 'Inga bokningar',
    noOrderReservedYet: 'Ingen beställning bokad än.',
    enableLocker: 'Ingen beställning bokad än.',
    noAlarms: 'Inga larm under vald tidsperiod',
    assignDeliveryFromDesk: 'Leverans hämtas från disken',
    updateDelivery: 'Uppdatering av leverans',
    assignDeliveryFromLocker: 'Leverans hämtas från Hämta!-box',
    assignToLocker:
      'Om du vill att denna leverans ska hämtas från en Hämta!-box, tryck på knappen "Till Pickupbox". Klicka på en ledig lucka, och välj “Tilldela bokning”.',
    pickedUpRevervation: 'Hämtas bokningen?',
    chooseDelivery: 'Välj leverans från listan',
    chooseThisDelivery: 'Välj denna leverans',
    onlyShelves:
      'Paketet innehåller produkter som inte får lämnas ut i utlämningsbox',
    pickupboxIsInactive: 'Pickupbox är inaktiv. Funktionen är inte tillgänglig',
    youReservationPinCode: 'Din bokning Pin-kod',
    wantResendSMS: 'Är du säker på att du vill skicka SMS på nytt?',
    enoughPermissions: 'Du har inte tillräckliga behörigheter',
    noContent: 'INTE INNEHÅLL.',
    locationNotAllowed: 'PLATS INTE TILLÅTEN',
    noSpaceInPickupBoxes: 'Inget utrymme i hämtningslådor',
    descriptionServiceRequest: 'Beskrivning av tjänstebegäran',
    choosePharmacy: 'Välj apotek som du vill logga in på',
    changePharmacy: 'Välj apotek',
    placeholderText: 'Välj Apotek',
    connectionLost: 'Internetanslutningen bruten',
    pickUpWithAnotherSSN:
      'Jag intygar att kontroll av att ombudet har korrekt fullmakt/kundens ID på plats vid utlämning',
    addPhoneNumber: 'Lägg till ett telefonnummer i bokningen',
    wrongSSN:
      'Det här är fel SSN för den här beställningen, kontrollera ID och verifiera igen',
    verifyDeliveryWithoutSSN: 'Verifiera leverans',
    cooling: 'Kylskåp',
    thisPeriod: 'Denna period',
    otherPeriod: 'Annan period',
    prevPeriod: 'Föregående period',
    average: 'Genomsnitt',
    customersAmount: 'Antal kunder',
    satisfiedCustomersAmount: 'Antal nöjda kunder',
    compareTo: 'Jämfört med föregående period',
    allFeedback: 'All feedback som har lämnats',
    reaction: 'reaktion',
    worstCategory: 'Sämsta kategori',
    bestCategory: 'Bästa kategori',
    mostDissatisfiedCustomersHours: 'Mest missnöjda kunder',
    clock: 'Klocka: ',
    generalSatisfaction: 'Allmän tillfredsställelse',
    customersSatisfaction: 'Kundnöjdhet',
    pickupDeliveries: 'Upphämtningsleveranser',
    customerFeedback: 'Kundefeedback',
    checkAllTemperatures: 'Kontrollera alla temperaturer',
    serialNumber: 'Serienummer',
    modelName: 'Modellnamn',
    pin: 'PIN',
    editSensor: 'Redigera sensor',
    addCommentSensor: 'Lägg till kommentar',
    active: 'Aktiv',
    translation: 'Översättning',
    totalCustomersVotes: 'Antal svarande: ',
    numberOfUsers: 'Antal svarande',
    position: 'Position',
    title: 'Titel',
    titleUpperCase: 'TITEL',
    subtitleUpperCase: 'UNDERTITEL',
    advertPhoto: 'Annons Foto',
    photoUpperCase: 'FOTO',
    screenTimeoutUpperCase: 'RESPONSTID FÖR SKÄRMEN',
    colorUpperCase: 'FÄRG',
    logoPhoto: 'Logotypfoto',
    chooseScale: 'Välj skala',
    chooseColor: 'Välj en färg',
    hintTextUpperCase: 'HINT TEXT',
    optionsUpperCase: 'RESPONS',
    addOption: 'Lägg till kategori',
    theSamePositions: 'Dessa alternativ har samma positioner',
    positionIsTaken: 'Den här positionen är redan upptagen, välj en annan',
    multipleOptions: 'Tillåt flera responsval',
    multipleOptionsUpperCase: 'TILLÅT FLERA RESPONSVAL',
    timeout: 'Responstid',
    addNewOption:
      'Du kan inte skapa ett nytt alternativ eftersom det redan finns tre aktiva alternativ',
    doNotSaveOption: 'Spara inte detta alternativ',
    settings: 'Kundfeedbacks inställningar',
    general: 'Allmänt',
    options: 'Kategorier',
    report: 'Textsvar',
    grade: 'Betyg',
    contact: 'Kontakt',
    contactUpperCase: 'KONTAKT',
    thanks: 'Tacksida',
    /*backTo*/
    backToUsers: 'Tillbaka till användare',
    backToInfoPickupBox:
      'Ingen beställning reserverad än. Aktivera pickupbox för att reservera beställningar.',
    backToCustomersFeedback: 'Tillbaka till Kundfeedback',
    /*lockers*/
    all: 'Allt',
    allUpperCase: 'ALLT',
    free: 'Ledig',
    reserved: 'Reserverad',
    reservedUpperCase: 'RESERVERAD',
    reservedTable: ' Reserverad',
    reservedText: 'reserverad',
    pickupTime: 'Hämtad',
    deleted: 'Borttagen',
    deletedTable: ' Borttagen',
    expired: 'Utgått',
    expiredTable: ' Utgått',
    notInUse: 'Ej i bruk',
    fridge: 'Kylskåp',
    delivered: 'Levererad på plats',
    deliveredUpperCase: 'LEVERERAD',
    deliveredTable: ' Levererad',
    removed: 'Borttagen',
    removedTable: ' Borttagen',
    disabled: 'Inaktiverad',
    cancelled: 'Inställd',
    cancelledTable: ' Inställd',
    cancelTime: 'Inställd',
    lost: 'Förlorad',
    lostTable: ' Förlorad',
    lostTime: 'Förlorad',
    pickedUp: 'Hämtad',
    pickup: 'Hämtad',
    pickedUpUpperCase: 'HÄMTAD',
    destroyedUpUpperCase: 'FÖRSTÖRD',
    pickedUpTable: ' Hämtad',
    destroyedTable: ' Förstörd',
    destroyed: 'Förstörd',
    auto_destroyed: 'Förstörd',
    small: 'Liten',
    medium: 'Mellan',
    large: 'Stor',
    semi_large: 'Stor',
    noSsn: 'Inget ID/personnummer',
    givenOutUserName: 'Utdelad användare',
    /*capacity Pick-up Box*/
    week: 'Vecka',
    weekUpperCase: 'VECKA',
    month: 'Månad',
    boxTypeUpperCase: 'FACKTYP',
    capacityUpperCase: 'KAPACITET %',
    averagePickupTimeUpperCase: 'SNITTHÄMTNINGSTID',
    /*edit Pick-up Box*/
    temperatureIntervals: 'Temperaturintervall',
    /*temperatureLog*/
    sensorUpperCase: 'LUCKANS ID/SENSOR',
    startTimeUpperCase: 'STARTTID',
    startTime: 'Starttid',
    endTimeUpperCase: 'SLUTTID',
    endTime: 'Sluttid',
    durationUpperCase: 'VARAKTIGHET',
    minUpperCase: 'MIN °C',
    maxUpperCase: 'MAX °C',
    averageUpperCase: 'MEDEL °C',
    alarmCommentUpperCase: 'LARMKOMMENTAR',
    date: 'Datum',
    temperature: 'Temperatur',
    temperatureMax: 'Temperatur Max',
    temperatureMin: 'Temperatur Min',
    timestempTemperatures: 'Bekräfta temperatur',
    lastCheckedBy: 'Senast kontrollerad av',
    checkTime: 'Kontrolltid',
    'Box Temperature': 'Box Temperatur',
    'Fridge 0-1 Temperature': 'Kylskåp 0-1 Temperatur',
    'Fridge 1-1 Temperature': 'Kylskåp 1-1 Temperatur',
    'Fridge 2-1 Temperature': 'Kylskåp 2-1 Temperatur',
    'Fridge 3-1 Temperature': 'Kylskåp 3-1 Temperatur',
    'Fridge 4-1 Temperature': 'Kylskåp 4-1 Temperatur',
    'Fridge 5-1 Temperature': 'Kylskåp 5-1 Temperatur',
    /*deliveryStatistics*/
    monthUpperCase: 'MÅNAD',
    yearUpperCase: 'ÅR',
    deliveriesUpperCase: '# LEVERANSER',
    pickupsUpperCase: '# UPPHÄMTNINGAR',
    expiredUpperCase: '# UTGÅNGNA',
    destroyedUpperCase: '# FÖRSTÖRDA',
    avgPickupTimeUpperCase: '# SNITT UPPHÄMTNINGSTID (T)',
    totalUsageUpperCase: '# TOTAL ANVÄNDNING (%)',
    total: 'Total',
    cancelledUpperCase: '# INSTÄLLDA',
    averagePickupTime: 'SNITT Hämtningstid',
    hoursUpperCase: 'Timmar',
    avgPickupTime: 'SNITTHÄMTNINGSTID',
    /*page*/
    pharmacy: 'Apotek',
    profile: 'Min information',
    pickupBox: 'Pickupboxar',
    pickupBoxes: 'PickupApotek',
    sensors: 'Sensorer',
    customersFeedback: 'Kundfeedback',
    customersSatisfactionReport: 'Kundnöjdhetsrapport',
    statistics: 'Statistik',
    users: 'Användare',
    user: 'Användare',
    mainUser: 'Huvudanvändare',
    userGuide: 'Användarguide',
    pharmacyInformation: 'Apoteksinformation',
    lockers: 'Luckor',
    order: 'Order',
    infoPickupBox: 'Pickubox info',
    boxInfo: 'Box info',
    editPickupBox: 'Redigera pickupbox',
    reservations: 'Bokningar',
    apiReservations: 'Viskan-bokningar',
    deliveryHistory: 'Leveranshistorik',
    temperatureLog: 'Temperaturlogg',
    alarms: 'Larm',
    capacity: 'Kapacitet',
    deliveryStatistics: 'Leveransstatistik',
    reserveLocker: 'Boka'
  },
  no: {
    account: 'Regnskap',
    login: 'Logg Inn',
    logout: 'Logg ut',
    loginWithMicrosoft: 'Logg på med Microsoft',
    pleaseWait: 'Vennligst vent',
    /*errors*/
    error: 'Feil',
    not_authorized: 'Brukeren er ikke autorisert',
    Unauthorized: 'Brukeren er ikke autorisert',
    user_is_not_admin: 'Brukeren må være admin',
    user_is_not_found: 'Brukeren er ikke funnet',
    error_login_user_not_found: 'Brukeren er ikke funnet',
    user_not_found: 'Brukeren ble ikke funnet',
    user_single_pharmacy: 'Brukeren har bare ett apotek',
    pharmacy_not_found: 'Apotek ikke funnet',
    pickupbox_not_found: 'Pickupbox ikke funnet',
    template_not_found: 'Mal ble ikke funnet',
    alarm_not_found: 'Alarm ikke funnet',
    delivery_not_found: 'Levering ikke funnet',
    delivery_has_no_ssn: 'Leveransen har ingen ssn-data',
    ssn_mismatch: 'SSN ikke samsvarer',
    link_not_found: 'Verifiseringslenke ble ikke funnet',
    not_enough_permissions: 'Ikke nok tillatelser til å utføre',
    error_session_expired: 'Økten er utløpt',
    no_content: 'Ikke noe innhold',
    forbidden: 'Nektet tilgang til apotek',
    not_found: 'Bruker ikke funnet',
    unknown: 'Ukjent feil',
    wrong_pin_code: 'Pin-koden er feil',
    wrong_phone_number: 'Telefonnummer stemmer ikke overens med leveransen',
    kolli_id_mismatch: 'Kolli Id mismatch',
    already_has_access:
      'Brukeren har allerede tilgang til det aktuelle apoteket',

    user_with_email_does_not_exist:
      'Bruker med denne e-postadressen eksisterer ikke',
    error_login_too_many_attempts:
      'For mange påloggingsforsøk prøver igjen senere',
    error_login_user_not_found_or_wrong_password:
      'Bruker ikke funnet eller feil passord',

    newPassword_missing: 'Endring av passord mislyktes',
    repeatNewPassword_missing: 'Endring av passord mislyktes',
    oldPassword_missing: 'Det gamle passordet mangler',
    newPassword_not_matches_repeatedNewPassword:
      'Det nye passordet samsvarer ikke med det gjentatte nye passordet',
    oldPassword_matches_newPassword:
      'Det gamle passordet samsvarer med det nye passordet',

    firstName_empty: 'Fornavnet er tomt',
    lastName_empty: 'Etternavnet er tomt',
    email_empty: 'E-postadressen er tom',
    invalid_role: 'Feil rolle',
    this_role_is_greater_than_yours: 'Denne rollen er større enn din',
    email_missing: 'E-postadressen mangler',
    firstName_missing: 'Fornavn mangler',
    lastName_missing: 'Etternavn mangler',
    appLanguage_missing: 'Appens språk mangler',
    role_missing: 'Rolle mangler',
    pharmacyIds_must_match: 'Apotek-ID må stemme overens',

    pharmacyId_missing: 'Apotek-ID mangler',
    webToolAccess_missing: 'Ingen tilgang til nettverktøyet',
    boxAccess_missing: 'Ingen tilgang til boksen',
    roleName_missing: 'Rollenavn mangler',
    role_not_exist: 'Rollen finnes ikke',

    name_missing: 'Navn mangler',
    businessId_missing: 'Virksomhets-ID mangler',
    not_valid_strong_auth_value: 'Ugyldig verdi strong auth',
    businessId_already_exists: 'Virksomhets-ID finnes allerede',
    pharmacy_templateId_missing: 'Apotekmal-ID mangler',
    pharmacy_id_missing: 'Apotek-ID mangler',
    pharmacy_country_missing: 'Apotekets land mangler',
    pharmacy_language_missing: 'Apotekets språk mangler',
    pharmacy_city_missing: 'Apotekets by mangler',
    pharmacy_outdoor_missing: 'Apotek utendørs mangler',
    pharmacy_uiLanguages_missing: 'Apotekets UI-språk mangler',
    pharmacy_zipCode_missing: 'Apotek postnummer mangler',
    pharmacy_cardboardType_missing: 'Apotekets papptype mangler',
    pharmacy_already_exists: 'Apoteket finnes allerede',
    pharmacy_does_not_exist: 'Det finnes ikke noe apotek',
    not_valid_strong_auth_value_pharmacy_update:
      'Ugyldig apotekoppdatering med en sterk autorisasjonsverdi',
    shelves_are_in_use_cant_change_number: 'Oppdatering av apotek mislyktes',

    pickupbox_templateId_missing: 'ID for henteboksmal mangler',
    pickupbox_name_missing: 'Pickupbox-navn mangler',
    pickupbox_id_missing: 'ID for henteboks mangler',
    pickupbox_country_missing: 'Pickupbox-land mangler',
    pickupbox_language_missing: 'Henteboksens språk mangler',
    pickupbox_city_missing: 'Pickupbox by mangler',
    pickupbox_outdoor_missing: 'Pickupbox utendørs mangler',
    pickupbox_uiLanguages_missing: 'Pickupbox UI-språk mangler',
    pickupbox_zipCode_missing: 'Pickupbox postnummer mangler',
    pickupbox_cardboardType_missing: 'Pickupbox papptype mangler',
    pickupbox_already_exists: 'Pickupbox finnes allerede',
    pickupbox__does_not_exist: 'Det finnes ingen pickupbox',

    missing_fields: 'Felt mangler',
    reserved_locker_cannot_be_inactive:
      'Et reservert skap kan ikke være inaktivt',
    locker_do_not_exist: 'Skapet finnes ikke',
    can_not_assign_to_box: 'Levering kan ikke tilordnes boks',

    user_is_logged_in_to_box: 'Brukeren er logget inn på kassen',
    reservation_delivered: 'Reservasjonen er levert',
    pickupbox_disabled: 'Henteboksen er slått av',
    user_is_logged_in_to_box_not_create_reservation:
      'Brukeren gikk inn i feltet for ikke å opprette en reservasjon',

    pickupbox_disabled_invalid_locker: 'Pickupboxen deaktiverte ugyldig skap',
    user_is_logged_in_to_box_invalid_locker:
      'Brukeren er logget på en ugyldig kasse',
    invalid_locker: 'Ugyldig skap',
    locker_already_reserved: 'Skapet er allerede reservert',
    wrong_delivery_status: 'Feil leveringsstatus',
    permissions_empty: 'Tillatelsene er tomme',
    bad_strong_auth_provider:
      'Dårlig serverkonfigurasjon, ingen leverandør for sterk autentisering oppgitt',
    authentication_link_has_expired: 'Autentiseringslenke har utløpt',

    validation: {
      required: 'Dette feltet er obligatorisk.',
      email: 'Vennligst skriv inn en gyldig e-postadresse.',
      phoneNumber: 'Format for telefonnummer: +xxxxxxxxxxxx',
      length: 'Dette feltet skal være 6 tegn langt.'
    },
    /*info*/
    address: 'Adresse',
    languages: 'Languages',
    versionSW: 'SW Versjon',
    temperatureInterval: 'Temperatur Intervall',
    temperatureAlarmInterval: 'Temperatur Alarmintervall',
    email: 'E-post',
    emailUpperCase: 'E-POST',
    alarmEmail: 'Alarm E-post',
    password: 'Passord',
    currentPassword: 'Nåværende passord',
    newPassword: 'Nytt passord',
    confirmPassword: 'Bekreft passord',
    phoneNumber: 'Telefonnummer',
    pinCode: 'PIN-kode',
    shelvesNumber: 'Antall hyller',
    chooseShelf: 'VELG HYLLE',
    show: 'utstilling',
    showUpperCase: 'Vis denne siden',
    mobilePhone: 'Mobiltelefon',
    mobilePhoneUpperCase: 'MOBILTELEFON',
    alarmPhoneNumber: 'Alarm Telefonnummer',
    firstName: 'Fornavn',
    firstNameUpperCase: 'FORNAVN',
    lastName: 'Etternavn',
    lastNameUpperCase: 'ETTERNAVN',
    name: 'Navn',
    nameUpperCase: 'NAVN',
    pharmacyNameUpperCase: 'APOTEKETS NAVN',
    roleUpperCase: 'ROLLE',
    role: 'Rolle',
    keyUpperCase: 'NØKKEL',
    key: 'Nøkkel',
    id: 'ID',
    reservationKeepTime: 'Reservasjon beholde tid',
    pickupBoxName: 'Henteboksnavn',
    pickupBoxId: 'Henteboks ID',
    city: 'By',
    country: 'Land',
    zipCode: 'Post Kode',
    UILanguages: 'UI Språk',
    defaultLanguages: 'Standardspråk',
    cardboardType: 'Henteboks papp type',
    userIdUpperCase: 'BRUKER-ID',
    deliveryStatusUpperCase: 'LEVERINGSSTATUS',
    deliveryStatus: 'Leveringsstatus',
    kolliIDUpperCase: 'KOLLI-ID',
    lockerID: 'Skap-ID',
    lockerIDUpperCase: 'SKÅP-ID',
    lockerIdOrShelfUpperCase: 'SKÅP-ID / PKT',
    lockerIdOrShelf: 'Skåp-ID / PKT',
    orderExpired: 'Ordren Utløpt',
    orderExpiredUpperCase: 'BESTILLING UTLØPT',
    causeOfAlarmUpperCase: 'ÅRSAK TIL ALARM',
    orderID: 'Bestillings-ID',
    lang: 'Språk',
    desktopLang: 'Skrivebordsspråk',
    pharmacyInfo: 'Apotekinfo',
    userBoxPin: 'Brukerboks-PIN',
    farmacyEntryPin: 'Inngangs-PIN for apotek',
    oldLogin: 'Gammel innlogging',
    newLogin: 'Ny innlogging',
    userBoxId: 'Brukerboks-ID',
    pharmacyReservations: 'Apotekreservasjoner',
    lastUpdate: 'Siste Oppdatering',
    kolliID: 'Kolli-ID',
    timeReserved: 'Reservert Tid',
    timeDelivery: 'Tidslevering',
    timePickup: 'Tid Henting',
    timeDelete: 'Tid Slettet',
    timeExpired: 'Tid Utløpt',
    deliveryMadeBy: 'Levering Utført Av',
    description: 'Beskrivelse',
    descriptionUpperCase: 'BESKRIVELSE',
    comment: 'Kommentar',
    resendSMSCounter: 'Antall sendte SMS:',
    resendSMSTimestamps: 'Tidspunkt for siste SMS sendt:',
    reservationMadeByUpperCase: 'RESERVERING FORETAET AV',
    deliveredByUpperCase: 'LEVERT AV',
    assignedTimeByUpperCase: 'TILDELT VED',
    assignedTime: 'Tildelt ved',
    assignedUserName: 'Tildelt',
    fulfillment_order_id: 'Oppfyllelsesordre-ID',
    order_id: 'Ordre-ID',
    reservedUserName: 'Reservering foretaet av',
    pickupboxPageAssignDelivery: 'LEVERING AV PICKUPBOX-SIDE',
    lastLoginUpperCase: 'SISTE INNLOGGING',
    userUpperCase: 'BRUKER',
    typeUpperCase: 'TYPE',
    assignUpperCase: 'TILDELE',
    alarmOk: 'Alt er i orden med skapet',
    alarmDoorOpen: 'Skapet lukkes ikke',
    alarmDoorClosed: 'Skapet åpnes ikke',
    alarmTempHigh: 'Temperaturen i skapet er høy',
    alarmTempLow: 'Temperaturen i skapet er lav',
    alarmOther: 'Ingen data om skapet er tilgjengelig',
    alarmMissing: 'Data om skapet mangler',
    connection_lost: 'Tilkoblingen mistet',
    january: 'Januar',
    february: 'Februar',
    march: 'Mars',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Desember',
    roomTemp: 'Romtemperatur',
    includesDrug: 'Inkluderer medikament',
    includesDrugUpperCase: 'INKLUDERER LEGEMIDDEL',
    narcoticsUpperCase: 'NARKOTIKA',
    log: 'Logg',
    min: 'min',
    minute: ' minutt',
    minutes: ' referat',
    hour: 'time',
    hours: 'timer',
    day: ' dag',
    days: ' dager',
    daysDelivery: 'Dager',
    basicLocker: 'Grunnleggende skap:',
    fridgeLocker: 'Kjøleskapsskap:',
    deliveryExpirationTime: 'Levering utløpstid',
    reminderMessageTime: 'Påminnelsesmelding tid',
    reservationExpirationTime: 'Reservasjon utløpstid',
    fullHistory: 'Full historikk',
    /*actions*/
    forgotPassword: 'Glemt Passord?',
    sendResetLink: 'Send tilbakestillingslink',
    backToLogIn: 'Tilbake til Logg inn',
    sentEmail: 'E-post for tilbakestilling av passord er sendt.',
    edit: 'Redigere',
    add: 'Legge til',
    chooseLanguage: 'Velg språk for SMS',
    save: 'Lagre',
    delete: 'Slett',
    cancel: 'Avbryt',
    cleanFields: 'Rene åker',
    search: 'Søk',
    makeServiceRequest: 'Lag en serviceforespørsel',
    seriviceRequested: 'Service forespurt',
    referToHelpdesk: 'Se vår helpdesk',
    addUser: 'Legg til Bruker',
    removeFromMyPharmacy: 'Fjern fra apoteket mitt',
    loginInformation: 'login Informasjon',
    selectMultipleLockers: 'Velg Flere Skap',
    chooseSeveralShelves: 'Velg flere hyller',
    disableLocker: 'Deaktiver Skap',
    locker: 'Skap',
    reservation: 'Reservasjon',
    delivery: 'Levering',
    deleteReservation: 'Slett Reservasjon',
    reserve: 'Reservere',
    newBookingPharmacyPickup: 'Ny bestilling for henting av apotek',
    exportJSON: 'Eksport.json',
    importJSON: 'Import.json',
    downloadCSV: 'Nedlasting.csv',
    downloadTempCSV: 'Last ned temperaturer.csv',
    downloadPDF: 'Nedlasting.pdf',
    createReservation: 'Opprett Reservasjon',
    webToolAccess: 'Tilgang til webverktøy',
    boxAccess: 'Tilgang til boks',
    ok: 'Ok',
    happy: 'Glad',
    angry: 'Sint',
    yes: 'Ja',
    no: 'Nei',
    noTable: 'Nei',
    and: 'og',
    verifySSN: 'Verifiera SSN',
    pickupForAnotherSSN: 'Hämta ett annat SSN',
    verify: 'Verifiser uten SSN',
    assignReservation: 'Henteboksside Tildel reservasjon',
    redirectToPickupBox: 'Omdirigere til henteboks',
    quickReservation: 'Rask reservasjon',
    quickReservationLockers: 'Manuell hurtigbestilling',
    isDrug: 'Narkotika inneholder',
    drug: 'Narkotika',
    ssn: 'SSN',
    ssnPickUp: 'Plukk opp SSN',
    ssnForOtherPerson: 'SSN for personen som henter',
    resendSMS: 'Send SMS på nytt',
    showFullHistory: 'Vis hele historikken',
    hideFullHistory: 'Skjul hele historikken',
    /*text*/
    pageNotFound: 'Side Ikke Funnet',
    checkURL:
      'Den angitte filen ble ikke funnet på denne nettsiden. Sjekk URL-en for feil og prøv igjen.',
    forgotPasswordTex:
      'Vennligst skriv inn e-postadressen din, så sender vi deg en e-post. Ved å følge lenken i e-posten vil du kunne skrive inn ditt nye passord.',
    passwordCharacters: 'Passordet skal inneholde minst 8 tegn.',
    youWantDelete: 'Er du sikker på at du vil slette',
    descriptionDestroy:
      'Ødelagt - Flytt reservasjonen til historikken. Dette skal brukes når du ødelegger.',
    descriptionDelete:
      'Slett - Flytt reservasjonen tilbake til "API-reservasjoner"-fanen, dvs. avbryt reservasjonen for å reservere en ny plass.',

    descriptionCancel: 'Avbryt - Lukk vinduet uten handling.',
    youWantDeleteReservation:
      'Er du sikker på at du vil slette denne reservasjonen? Denne endringen kan ikke angres',
    undone: '? Denne endringen kan ikke angres.',
    changePasswordInfo:
      'INFO: Husk passordet og overgi det til brukeren. Du kan ikke gjenopprette passordet senere. Passordet skal inneholde minst 8 tegn.',
    noPickupBox: 'Ingen Hente Boks',
    noFeedback: 'Ingen tilbakemelding',
    addDescription: 'Legg til beskrivelse i leveringshistorikken',
    infoReservation: 'Informasjon om reservasjonen',
    addAlarmComment: 'Legg til alarmkommentar',
    deviationsInTimeFrame: 'Avvik i tidsramme',
    addUserMainInfo:
      'INFO: Husk passordet og overgi det til brukeren. Du kan ikke gjenopprette passordet senere.',
    addUserInfo: 'Passordet skal inneholde minst 8 tegn.',
    lockersSelected: 'skap er valgt',
    messageTemperatureHigh: 'Skaptemperaturen er for høy: ',
    messageTemperatureLow: 'Skaptemperaturen er for lav: ',
    noData: 'Ingen data',
    errorDate: 'Feil dato',
    noReservations: 'Ingen reservasjoner',
    noOrderReservedYet: 'Ingen bestilling er reservert ennå.',
    enableLocker:
      'Ingen bestilling er reservert ennå. Aktiver Locker for å reservere bestillinger.',
    noAlarms: 'Ingen alarmer i den valgte tidsperioden',
    assignDeliveryFromDesk:
      'Tilordne levering som skal hentes fra skrivebordet',
    updateDelivery: 'Oppdater levering',
    assignDeliveryFromLocker:
      'Tilordne levering som skal hentes fra henteboksen',
    assignToLocker:
      'Hvis du vil at leveransen skal hentes fra en Pickup!-boks, trykker du på knappen "Omdirigere til henteboks". Klikk på en ledig plass, og velg "assignReservation".',
    pickedUpRevervation: 'Ble reservasjonen hentet?',
    chooseDelivery: 'Velg leveransen fra listen',
    chooseThisDelivery: 'Velg denne leveransen',
    onlyShelves: 'Pakken inneholder varer som ikke kan legges i en postkasse',
    pickupboxIsInactive:
      'Pickupbox er inaktiv. Funksjonen er ikke tilgjengelig',
    youReservationPinCode: 'Pin-kode for din reservasjon',
    wantResendSMS: 'Er du sikker på at du vil sende SMS på nytt?',
    enoughPermissions: 'Du har ikke nok tillatelser',
    noContent: 'INGEN INNHOLD.',
    locationNotAllowed: 'PLASSERING IKKE TILLATT',
    noSpaceInPickupBoxes: 'Ingen plass i oppsamlingsbokser',
    descriptionServiceRequest: 'Beskrivelse av tjenesteforespørselen',
    choosePharmacy: 'Velg apoteket du vil logge inn på',
    changePharmacy: 'Endre Apotek',
    placeholderText: 'Velg Apotek',
    connectionLost: 'Internettforbindelsen er brutt',
    pickUpWithAnotherSSN:
      'Jeg bekrefter at representanten har korrekt fullmakt/kunde-ID på stedet ved levering',
    addPhoneNumber: 'Legg til et telefonnummer i reservasjonen',
    wrongSSN:
      'Dette er feil SSN for denne bestillingen, vennligst sjekk ID og bekreft på nytt',
    verifyDeliveryWithoutSSN: 'Bekreft levering',
    cooling: 'Kjøling',
    thisPeriod: 'Denne perioden',
    otherPeriod: 'Annen periode',
    prevPeriod: 'Forrige periode',
    average: 'Gjennomsnitt',
    customersAmount: 'Antall kunder',
    satisfiedCustomersAmount: 'Antall fornøyde kunder',
    compareTo: 'Sammenlign med forrige periode',
    allFeedback: 'All tilbakemelding som har forlatt',
    reaction: 'reaksjon',
    worstCategory: 'Verste kategori',
    bestCategory: 'Beste kategori',
    mostDissatisfiedCustomersHours: 'Mest misfornøyde kunder',
    clock: 'Klokke: ',
    generalSatisfaction: 'Generell tilfredshet',
    customersSatisfaction: 'Kundetilfredshet',
    pickupDeliveries: 'Henting av leveranser',
    customerFeedback: 'Kundefeedback',
    checkAllTemperatures: 'Sjekk alle temperaturer',
    serialNumber: 'Serienummer',
    modelName: 'Modellnavn',
    pin: 'PIN',
    editSensor: 'Rediger sensor',
    addCommentSensor: 'Legg til kommentar',
    active: 'Aktiv',
    translation: 'Oversettelse',
    totalCustomersVotes: 'Antall respondenter: ',
    numberOfUsers: 'Antall respondenter',
    position: 'Stilling',
    title: 'Tittel',
    titleUpperCase: 'TITTEL',
    subtitleUpperCase: 'UNDERTITEL',
    advertPhoto: 'Annonsefoto',
    photoUpperCase: 'FOTO',
    screenTimeoutUpperCase: 'TIDSAVBRUDD PÅ SKJERMEN',
    colorUpperCase: 'FARGE',
    logoPhoto: 'Logo Foto',
    chooseScale: 'Velg skala',
    chooseColor: 'Velg en farge',
    hintTextUpperCase: 'HINT TEKST',
    optionsUpperCase: 'ALTERNATIVER',
    addOption: 'Legg til alternativ',
    theSamePositions: 'Disse alternativene har de samme posisjonene',
    positionIsTaken: 'Denne posisjonen er allerede opptatt, velg en annen',
    multipleOptions: 'Flere alternativer',
    multipleOptionsUpperCase: 'FLERE ALTERNATIVER',
    timeout: 'Tidsavbrudd',
    addNewOption:
      'Du kan ikke opprette et nytt alternativ fordi det allerede finnes tre aktive alternativer',
    doNotSaveOption: 'Ikke lagre dette alternativet',
    settings: 'Innstillinger Kunder Tilbakemeldinger',
    general: 'Generelt',
    options: 'Alternativer',
    report: 'Rapporter',
    grade: 'Karakter',
    contact: 'Kontakt',
    contactUpperCase: 'KONTAKT',
    thanks: 'Takk',
    /*backTo*/
    backToUsers: 'Tilbake til Brukere',
    backToInfoPickupBox: 'Tilbake til Info Hente Boks',
    backToCustomersFeedback: 'Tilbake til tilbakemeldinger fra kunder',
    /*lockers*/
    all: 'Alle',
    allUpperCase: 'ALLE',
    free: 'Gratis',
    reserved: 'Reservert',
    reservedUpperCase: 'RESERVERT',
    reservedTable: ' Reservert',
    reservedText: 'reservert',
    pickupTime: 'Plukket Opp',
    deleted: 'Slettet',
    deletedTable: ' Slettet',
    expired: 'Utløpt',
    expiredTable: ' Utløpt',
    notInUse: 'Ikke i bruk',
    fridge: 'Kjøleskap',
    delivered: 'Leveres på stedet',
    deliveredUpperCase: 'LEVERES',
    deliveredTable: ' Levert',
    removed: 'Fjernet',
    removedTable: ' Fjernet',
    disabled: 'Deaktivert',
    cancelled: 'Avbrutt',
    cancelledTable: ' Avbrutt',
    cancelTime: 'Avbrutt',
    lost: 'Tapt',
    lostTable: ' Tapt',
    lostTime: 'Tapt',
    pickedUp: 'Plukket Opp',
    pickup: 'Plukket Opp',
    pickedUpUpperCase: 'PLUKKET OPP',
    destroyedUpUpperCase: 'ØDELAGT',
    pickedUpTable: ' Plukket Opp',
    destroyedTable: ' Ødelagt',
    destroyed: 'Ødelagt',
    auto_destroyed: 'Ødelagt',
    small: 'Liten',
    medium: 'Medium',
    large: 'Stort',
    semi_large: 'Stort',
    noSsn: 'Ingen SSN',
    givenOutUserName: 'Gitt ut bruker',
    /*capacity Pick-up Box*/
    week: 'Uke',
    weekUpperCase: 'UKE',
    month: 'Måned',
    boxTypeUpperCase: 'BOKSTYPE',
    capacityUpperCase: 'KAPASITET %',
    averagePickupTimeUpperCase: 'GJENNOMSNITTLIG HENTETID',
    /*edit Pick-up Box*/
    temperatureIntervals: 'Temperaturintervaller',
    /*temperatureLog*/
    sensorUpperCase: 'SKAP-ID/SENSOR',
    startTimeUpperCase: 'STARTTID',
    startTime: 'Starttid',
    endTimeUpperCase: 'SLUTTID',
    endTime: 'Sluttid',
    durationUpperCase: 'VARIGHET',
    minUpperCase: 'MIN °C',
    maxUpperCase: 'MAX °C',
    averageUpperCase: 'GJENNOMSNITT °C',
    alarmCommentUpperCase: 'ALARMKOMMENTAR',
    date: 'Dato',
    temperature: 'Temperatur',
    temperatureMax: 'Max Temperatur',
    temperatureMin: 'Min Temperatur',
    timestempTemperatures: 'Kontroller temperaturene',
    lastCheckedBy: 'Sist sjekket av',
    checkTime: 'Kontrolltid',
    'Box Temperature': 'Temperatur i boksen',
    'Fridge 0-1 Temperature': 'Kjøleskap 0-1 Temperatur',
    'Fridge 1-1 Temperature': 'Kjøleskap 1-1 Temperatur',
    'Fridge 2-1 Temperature': 'Kjøleskap 2-1 Temperatur',
    'Fridge 3-1 Temperature': 'Kjøleskap 3-1 Temperatur',
    'Fridge 4-1 Temperature': 'Kjøleskap 4-1 Temperatur',
    'Fridge 5-1 Temperature': 'Kjøleskap 5-1 Temperatur',
    /*deliveryStatistics*/
    monthUpperCase: 'MÅNED',
    yearUpperCase: 'ÅR',
    deliveriesUpperCase: '# LEVERINGER',
    pickupsUpperCase: '# HENTER',
    expiredUpperCase: '# UTLØPT',
    destroyedUpperCase: '# ØDELAGTE',
    avgPickupTimeUpperCase: '# AVG HENTETID (T)',
    totalUsageUpperCase: '# TOTAL BRUK (%)',
    total: 'Total',
    cancelledUpperCase: '# KANSELLERT',
    averagePickupTime: 'AVG Hentetid',
    hoursUpperCase: 'Timer',
    avgPickupTime: 'GJENNOMSNITTLIG HENTETID',
    /*page*/
    pharmacy: 'Apotek',
    profile: 'Min informasjon',
    pickupBox: 'Hente Boks',
    pickupBoxes: 'Hente Bokser',
    sensors: 'Sensorer',
    customersFeedback: 'Tilbakemeldinger Fra Kunder',
    customersSatisfactionReport: 'Kundetilfredshetsrapport',
    statistics: 'Statistikk',
    users: 'Brukere',
    user: 'Bruker',
    mainUser: 'Hovedbruker',
    userGuide: 'Brukerveiledning',
    pharmacyInformation: 'Apotekinformasjon',
    lockers: 'Skap',
    order: 'Rekkefølge',
    infoPickupBox: 'Henteboksinfo',
    boxInfo: 'Boksinfo',
    editPickupBox: 'Rediger Henteboks',
    reservations: 'Reservasjoner',
    apiReservations: 'API-reservasjoner',
    deliveryHistory: 'Leveringshistorikk',
    temperatureLog: 'Temperaturlogg',
    alarms: 'Alarmer',
    capacity: 'Kapasitet',
    deliveryStatistics: 'Leveringsstatistikk',
    reserveLocker: 'Reserve Skap'
  }
};
